<div class="createclient-modal-container">
  <form #addClientForm="ngForm" (ngSubmit)="saveClienttInfo(addClientForm,false)" class="" novalidate>
    <div class="col-sm-12 p-0">
      <div class="createclient-modal">
        <div class="client-content">
          <div class="cmn-modal-header">
            <h4 class="modal-header-title">{{buttontext}} client</h4>
          </div>
          <div class="cmn-modal-content">
            <div class="createclient-top-stepper">
              <div class="createclient-top-stepper-row">
                <div class="createclient-top-stepper-row-item" [ngClass]="{'active-stepper-item' : currentPage == 0}">
                  <div class="createclient-top-stepper-row-item-circle">
                    <img src="../../../../assets/img/client/addClientIcons/profile_grey.svg" *ngIf="currentPage !== 0" />
                    <img src="../../../../assets/img/client/addClientIcons/userAddIcon.svg" *ngIf="currentPage === 0" />
                  </div>
                  <h5 class="createclient-top-stepper-row-item-title">
                    <span>Basic</span>
                  </h5>
                </div>
                <div class="createclient-top-stepper-row-item" [ngClass]="{'active-stepper-item' : currentPage == 1}">
                  <div class="createclient-top-stepper-row-item-circle">
                    <img src="../../../../assets/img/client/addClientIcons/FinancialIcon.svg" alt="financialIcon" *ngIf="currentPage == 2 || currentPage == 3" />
                    <img src="../../../../assets/img/client/addClientIcons/financialWhite.svg" alt="financialIcon" *ngIf="currentPage == 1" />
                  </div>
                  <h5 class="createclient-top-stepper-row-item-title">
                    <span *ngIf="currentPage == 0 || currentPage == 1">Financial</span>
                  </h5>
                </div>
              </div>
            </div>
            <div class="createclient-stepper-content" [ngClass]="{'createcontact-screen-enable':contactHide}">
              <!-- Basic start-->
              <div class="basicInfo-stepper-content" *ngIf="currentPage == 0">
                <div class="row m-0">
                  <div class="col-4" *ngIf="buttontext=='Create'">
                    <div class="form-group form-group-sm">
                      <h6 class="cmn-form-label">Entity type<span class="error-text">*</span></h6>
                      <div class="form-select-container">
                        <ng-select [items]="entitytype" class="cmn-ngselect"
                                   bindLabel="entityTypeName"
                                   bindValue="entityTypeId"
                                   [clearable]="false" id="entityTypeId" name="entityTypeId" #entityTypeId="ngModel" (change)="onChangeEType($event); onChangeEntity();"
                                   [(ngModel)]="clientDataModal.entityTypeId" [ngClass]="{'is-invalid':addClientForm.submitted && entityTypeId.invalid }"
                                   placeholder="Select entity type"
                                   data-testid="drpdwn-entity-type-create">

                          <ng-template ng-option-tmp let-item="item" let-index="index">
                            <span class=""> {{item.entityTypeName.length > 15 ? (item.entityTypeName| slice:0:15) + '..' : item.entityTypeName}}</span>
                          </ng-template>
                        </ng-select>
                        <div *ngIf="addClientForm.submitted && entityTypeId.invalid" class="invalid-feedback invalid">
                          <div *ngIf="entityTypeId.errors.required">
                            Category is required
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-4" *ngIf="buttontext=='Update '">
                    <div class="form-group form-group-sm">
                      <h6 class="cmn-form-label">Entity type<span class="error-text">*</span></h6>
                      <div class="form-select-container">
                        <ng-select [items]="entitytype" class="cmn-ngselect cmn-ngselects"
                                   bindLabel="entityTypeName"
                                   bindValue="entityTypeId"
                                   [clearable]="false" id="entityTypeId" name="entityTypeId" #entityTypeId="ngModel" (change)="onChangeEType($event); onChangeEntity();"
                                   [(ngModel)]="clientDataModal.entityTypeId" [ngClass]="{'is-invalid':addClientForm.submitted && entityTypeId.invalid }"
                                   placeholder="Select entity type" data-testid="drpdwn-address-type-update" disabled>

                          <ng-template ng-option-tmp let-item="item" let-index="index">
                            <span class=""> {{item.entityTypeName.length > 15 ? (item.entityTypeName| slice:0:15) + '..' : item.entityTypeName}}</span>
                          </ng-template>
                        </ng-select>
                        <div *ngIf="addClientForm.submitted && entityTypeId.invalid" class="invalid-feedback invalid">
                          <div *ngIf="entityTypeId.errors.required">
                            Category is required
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-4">
                    <div class="form-group form-group-sm">
                      <h6 class="cmn-form-label">Client code<span class="error-text">*</span></h6>

                      <div *ngIf="isAuto && buttontext=='Create'" class="form-input-container">
                        <input type="text" class="form-control readonly-grey" data-testid="input-client-code" autocomplete="off" [(ngModel)]="clientDataModal.clientCode" name="ClientCodedd" maxlength="20" #ClientCodedd="ngModel" (change)="checkOnchangefield();" [(ngModel)]="clientDataModal.clientCode" placeholder="Enter Client Code" required [ngClass]="{'is-invalid':(addClientForm.submitted && ClientCodedd.invalid) || _flagCodeExist }" readonly />
                        <div *ngIf="addClientForm.submitted && ClientCodedd.invalid" class="invalid-feedback invalid">
                          <div *ngIf="ClientCodedd.errors.required">
                            Client code is required
                          </div>
                        </div>
                        <div *ngIf="_flagCodeExist" class="invalid-feedback invalid">
                          <div class="kc-client-exist">
                            Client code already exists, please enter a unique code.
                          </div>
                        </div>
                      </div>

                      <div *ngIf="isAuto==false && buttontext=='Create'" class="form-input-container">
                        <input type="text" class="form-control" data-testid="input-client-code-alt" autocomplete="off" [(ngModel)]="clientDataModal.clientCode" name="ClientCodedd" maxlength="20" #ClientCodedd="ngModel" (change)="checkOnchangefield();validateClientCode();isClientCodeValid();" [(ngModel)]="clientDataModal.clientCode" placeholder="Enter Client Code" required [ngClass]="{'is-invalid':(addClientForm.submitted && ClientCodedd.invalid) || _flagCodeExist }" />
                        <div *ngIf="addClientForm.submitted && ClientCodedd.invalid" class="invalid-feedback invalid">
                          <div *ngIf="ClientCodedd.errors.required">
                            Client code is required
                          </div>
                        </div>
                        <div *ngIf="_flagCodeExist || clientCodeExists" class="invalid-feedback invalid">
                          <div class="kc-client-exist">
                            Client code already exists, please enter a unique code.
                          </div>
                        </div>
                        <div *ngIf="invalidClientCode" class="invalid-feedback invalid">
                          <div class="kc-client-exist">
                            Client code should be alphanumeric only.
                          </div>
                        </div>
                      </div>
                      <div *ngIf="buttontext=='Update '" class="form-input-container">
                        <input type="text" class="form-control readonly-grey" data-testid="input-client-code-update" autocomplete="off" [(ngModel)]="clientDataModal.clientCode" name="ClientCodedd" maxlength="20" #ClientCodedd="ngModel" (change)="checkOnchangefield();" [(ngModel)]="clientDataModal.clientCode" placeholder="Enter Client Code" required [ngClass]="{'is-invalid':(addClientForm.submitted && ClientCodedd.invalid) || _flagCodeExist }" readonly />
                        <div *ngIf="addClientForm.submitted && ClientCodedd.invalid" class="invalid-feedback invalid">
                          <div *ngIf="ClientCodedd.errors.required">
                            Client code is required
                          </div>
                        </div>
                        <div *ngIf="_flagCodeExist" class="invalid-feedback invalid">
                          <div class="kc-client-exist">
                            Client code already exists, please enter a unique code.
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group form-group-sm form-inline prospect-control">
                      <h6 class="cmn-form-label mr-3 mb-0">Prospect</h6>
                      <div class="cmn-slide-toggle-container">
                        <mat-slide-toggle name="prospect" (change)="checkOnchangefield();" [(ngModel)]="clientDataModal.prospect" color="primary" data-testid="tgl-client-prospect"></mat-slide-toggle>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="basic-info-container">
                  <h4 class="createclient-section-title">Basic info</h4>
                  <!--Individual Basic Start-->
                  <div class="createclient-section-row" *ngIf="clientDataModal.entityTypeId != 2 && clientDataModal.entityTypeId != 3 && clientDataModal.entityTypeId != 4 && clientDataModal.entityTypeId != 5">
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Title</h6>
                        <div class="col-3">
                          <div class="form-select-container">
                            <ng-select [items]="titleList" class="cmn-ngselect" data-testid="drpdwn-salutation-individual"
                                       bindLabel="title"
                                       bindValue="title"
                                       [clearable]="true" id="title" name="title" #title="ngModel"
                                       placeholder="Select title" (change)="checkOnchangefield();" [(ngModel)]="clientDataModal.title">

                              <ng-template ng-option-tmp let-item="item" let-index="index">
                               <span class=""> {{item.title.length > 20 ? (item.title| slice:0:20) + '..' : item.title}}</span>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Name<span class="error-text">*</span>
                        </h6>
                        <div class="col-3">
                          <div class="form-input-container">
                            <input type="text" class="form-control" maxlength="128" name="firstname" data-testid="input-first-name-individual" #firstname="ngModel" autocomplete="off" (change)="generateClientCode();checkOnchangefield();" (keyup)="prefillPreferredName();$event.preventDefault();" [(ngModel)]="clientDataModal.firstname" placeholder="Enter first name*" required [ngClass]="{'is-invalid':addClientForm.submitted && firstname.invalid }" />
                            <div *ngIf="addClientForm.submitted && firstname.invalid" class="invalid-feedback invalid position_kc_step">
                              <div *ngIf="firstname.errors.required">
                                First name is required
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-3">
                          <div class="form-input-container">
                            <input type="text" class="form-control" maxlength="128" autocomplete="off" name="middlename" data-testid="input-middle-name-individual" #middlename="ngModel" [(ngModel)]="clientDataModal.middlename" (change)="checkOnchangefield();" placeholder="Enter middle name" />
                          </div>
                        </div>
                        <div class="col-3">
                          <div class="form-input-container">
                            <input type="text" class="form-control" maxlength="128" autocomplete="off" name="lastname" data-testid="input-last-name-individual" #lastname="ngModel" (change)="generateClientCode();checkOnchangefield();" [(ngModel)]="clientDataModal.lastname" placeholder="Enter last name*" required [ngClass]="{'is-invalid':addClientForm.submitted && lastname.invalid }" />
                            <div *ngIf="addClientForm.submitted && lastname.invalid" class="invalid-feedback invalid position_kc_step">
                              <div *ngIf="lastname.errors.required">
                                Last name is required
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Salutation<span class="error-text">*</span>
                        </h6>
                        <div class="col-9">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="salutation" data-testid="input-salutation-individual" autocomplete="off" #salutation="ngModel" maxlength="404" [(ngModel)]="clientDataModal.salutation" placeholder="Enter salutation" required [ngClass]="{'is-invalid':addClientForm.submitted && salutation.invalid }"/>
                             <div *ngIf="addClientForm.submitted && salutation.invalid" class="invalid-feedback invalid position_kc_step">
                              <div *ngIf="salutation.errors.required">
                                Salutation is required
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Preferred name
                        </h6>
                        <div class="col-9">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="preferredname" data-testid="input-preferred-name-individual" autocomplete="off" maxlength="128" (change)="checkOnchangefield();" [(ngModel)]="clientDataModal.preferredname" placeholder="Enter preferred name" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Trading as
                        </h6>
                        <div class="col-9">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="tradingName" data-testid="input-trading-name-individual" #tradingName="ngModel" maxlength="200" autocomplete="off" [(ngModel)]="clientDataModal.tradingName" (change)="checkOnchangefield();" placeholder="Enter trading name" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngTemplateOutlet="commonTextArea; context: { label: 'Mailing name', name: 'mailingName', dataTestid: 'textarea-mailing-name-individual',
                      maxlength: 500, placeholder: 'Enter mailing name', changeFn: 'checkOnchangefield', required: true }">
                    </ng-container>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'Date of birth', name: 'dateofbirth', max: maxDate, dataTestid: 'datepkr-dob-individual', changeHandler: checkOnchangefield, maxValueName: 'dateOfDeath' }">
                    </ng-container>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'Date of death', name: 'dateOfDeath', min: 'dateofbirth', max: maxDate, dataTestid: 'datepkr-dod-individual', changeHandler: checkOnchangefield }">
                    </ng-container>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'Start date', name: 'clientStartDate', max: maxDate, dataTestid: 'datepkr-start-date-individual', changeHandler: checkOnchangefield, maxValueName: 'clientEndDate' }">
                    </ng-container>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'End date', name: 'clientEndDate', min: 'clientStartDate', max: maxDate, dataTestid: 'datepkr-end-date-individual', changeHandler: checkOnchangefield }">
                    </ng-container>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Place of birth
                        </h6>
                        <div class="col-3">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="placeofbirth" data-testid="input-place-of-birth-individual" autocomplete="off" maxlength="128" (change)="checkOnchangefield();" [(ngModel)]="clientDataModal.placeofbirth" placeholder="Enter place of birth" tabindex="0" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm gender-kc-template">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Gender
                        </h6>
                        <div class="col-3">
                          <div class="normal-form-select-arrow">
                            <select class="form-control" name="gender" data-testid="drpdwn-gender-individual" (change)="checkOnchangefield();" [(ngModel)]="clientDataModal.gender">
                              <option selected="selected" disabled value=undefined>Select gender</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                              <option value="Unspecified">Unspecified</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--company Basic Start-->
                  <div class="createclient-section-row" *ngIf="clientDataModal.entityTypeId == 2">
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Company name<span class="error-text">*</span>
                        </h6>
                        <div class="col-9">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="companyName" data-testid="input-company-name" #companyName="ngModel" maxlength="200" autocomplete="off" (change)="generateClientCode();checkOnchangefield();" [(ngModel)]="clientDataModal.companyName" placeholder="Enter name" required [ngClass]="{'is-invalid':addClientForm.submitted && companyName.invalid }" />
                            <div *ngIf="addClientForm.submitted && companyName.invalid" class="invalid-feedback invalid position_kc_step">
                              <div *ngIf="companyName.errors.required">
                                Company name is required
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Trading as
                        </h6>
                        <div class="col-9">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="tradingName" data-testid="input-trading-name-company" #tradingName="ngModel" maxlength="200" autocomplete="off" [(ngModel)]="clientDataModal.tradingName" (change)="checkOnchangefield();" placeholder="Enter trading name" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Salutation<span class="error-text">*</span>
                        </h6>
                        <div class="col-9">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="salutation" data-testid="input-salutation-company" autocomplete="off" #salutation="ngModel" maxlength="404" [(ngModel)]="clientDataModal.salutation" placeholder="Enter salutation" required [ngClass]="{'is-invalid':addClientForm.submitted && salutation.invalid }"/>
                             <div *ngIf="addClientForm.submitted && salutation.invalid" class="invalid-feedback invalid position_kc_step">
                              <div *ngIf="salutation.errors.required">
                                Salutation is required
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngTemplateOutlet="commonTextArea; context: { label: 'Mailing name', name: 'mailingName', dataTestid: 'textarea-mailing-name-individual',
                      maxlength: 500, placeholder: 'Enter mailing name', changeFn: 'checkOnchangefield', required: true }">
                    </ng-container>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Preferred name
                        </h6>
                        <div class="col-9">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="preferredname" data-testid="input-preferred-name-company" autocomplete="off" maxlength="128" (change)="checkOnchangefield();" [(ngModel)]="clientDataModal.preferredname" placeholder="Enter preferred name" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'Formation date', name: 'formationDate', max: maxDate, dataTestid: 'datepkr-formation-date-company', changeHandler: checkOnchangefield, maxValueName: 'deRegistrationDate' }">
                    </ng-container>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'Deregistration date', name: 'deRegistrationDate', min: 'formationDate', max: maxDate, dataTestid: 'datepkr-deresgistration-date-company', changeHandler: checkOnchangefield }">
                    </ng-container>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Annual review date
                        </h6>
                        <div class="col-3">
                          <div class="form-datepicker-container cmn-material-datepicker">
                            <mat-form-field floatLabel="never" appearance="standard">
                              <input class="cmn-mat-dtpicker-input" matInput
                                     #annualReviewDate="ngModel"
                                     (dateChange)="checkOnchangefield()"
                                     [(ngModel)]="clientDataModal.annualReviewDate" [matDatepicker]="annualReviewDateDatepicker"
                                     name="annualReviewDate" autocomplete="off" placeholder="dd/mm/yyyy"
                                     data-testid="datepkr-annual-review-date-company">
                              <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" matIconSuffix [for]="annualReviewDateDatepicker"></mat-datepicker-toggle>
                              <mat-datepicker panelClass="cmn-datepicker-ui"
                                              #annualReviewDateDatepicker></mat-datepicker>
                              <mat-error class="cmn-material-datepicker-errormsg">
                                Please enter the date in dd/mm/yyyy
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'Start date', name: 'clientStartDate', max: maxDate, dataTestid: 'datepkr-client-start-date', changeHandler: checkOnchangefield, maxValueName: 'clientEndDate' }">
                    </ng-container>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'End date', name: 'clientEndDate', min: 'clientStartDate', max: maxDate, dataTestid: 'datepkr-client-end-date', changeHandler: checkOnchangefield }">
                    </ng-container>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Website
                        </h6>
                        <div class="col-3">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="website" data-testid="input-website-company" maxlength="50" autocomplete="off" [(ngModel)]="clientDataModal.website" (change)="checkOnchangefield();" placeholder="Enter website" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--company Basic end-->
                  <!--Trust  Start-->
                  <div class="createclient-section-row" *ngIf="clientDataModal.entityTypeId == 3">
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Trust name<span class="error-text">*</span>
                        </h6>
                        <div class="col-9">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="trustName" data-testid="input-trust-name" #trustName="ngModel" autocomplete="off" required maxlength="128" [(ngModel)]="clientDataModal.trustName" (change)="generateClientCode();checkOnchangefield();" placeholder="Enter name" [ngClass]="{'is-invalid':addClientForm.submitted && trustName.invalid }" />
                            <div *ngIf="addClientForm.submitted && trustName.invalid" class="invalid-feedback invalid position_kc_step">
                              <div *ngIf="trustName.errors.required">
                                Trust name is required
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Type of trust
                        </h6>
                        <div class="col-9">
                          <div class="normal-form-select-arrow ">
                            <select class="form-control" name="trustType" data-testid="drpdwn-trust-type" [(ngModel)]="clientDataModal.trustType" (change)="checkOnchangefield();">
                              <option value=undefined selected="selected" disabled>Trust type</option>
                              <option>Discretionary</option>
                              <option>Hybrid</option>
                              <option>Unit</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Trading as
                        </h6>
                        <div class="col-9">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="tradingName" data-testid="input-trading-name-trust" #tradingName="ngModel" maxlength="200" autocomplete="off" [(ngModel)]="clientDataModal.tradingName" (change)="checkOnchangefield();" placeholder="Enter trading name" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Salutation<span class="error-text">*</span>
                        </h6>
                        <div class="col-9">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="salutation" data-testid="input-salutation-trust" autocomplete="off" #salutation="ngModel" maxlength="404" [(ngModel)]="clientDataModal.salutation" placeholder="Enter salutation" required [ngClass]="{'is-invalid':addClientForm.submitted && salutation.invalid }"/>
                             <div *ngIf="addClientForm.submitted && salutation.invalid" class="invalid-feedback invalid position_kc_step">
                              <div *ngIf="salutation.errors.required">
                                Salutation is required
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngTemplateOutlet="commonTextArea; context: { label: 'Mailing name', name: 'mailingName', dataTestid: 'textarea-mailing-name-trust',
                      maxlength: 500, placeholder: 'Enter mailing name', changeFn: 'checkOnchangefield', required: true }">
                    </ng-container>
                      <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Preferred name
                        </h6>
                        <div class="col-9">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="preferredname" data-testid="input-preferred-name-trust" autocomplete="off" maxlength="128" (change)="checkOnchangefield();" [(ngModel)]="clientDataModal.preferredname" placeholder="Enter preferred name" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'Formation date', name: 'formationDate', max: maxDate, dataTestid: 'datepkr-formation-date-trust', changeHandler: checkOnchangefield, maxValueName: 'deRegistrationDate' }">
                    </ng-container>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'Deregistration date', name: 'deRegistrationDate', min: 'formationDate', max: maxDate, dataTestid: 'datepkr-deregistration-date-trust', changeHandler: checkOnchangefield }">
                    </ng-container>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'Start date', name: 'clientStartDate', max: maxDate, dataTestid: 'datepkr-client-start-date', changeHandler: checkOnchangefield, maxValueName: 'clientEndDate' }">
                    </ng-container>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'End date', name: 'clientEndDate', min: 'clientStartDate', max: maxDate, dataTestid: 'datepkr-client-end-date', changeHandler: checkOnchangefield }">
                    </ng-container>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Website
                        </h6>
                        <div class="col-3">
                          <div class="form-input-container">
                            <input type="text" class="form-control" autocomplete="off" name="website1" data-testid="input-website-trust" maxlength="50" [(ngModel)]="clientDataModal.website" (change)="checkOnchangefield();" placeholder="Enter website" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--Trust  end-->
                  <!--Partership Basic Start-->
                  <div class="createclient-section-row" *ngIf="clientDataModal.entityTypeId == 4">
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Partnership name<span class="error-text">*</span>
                        </h6>
                        <div class="col-9">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="partnershipname" data-testid="input-partnership-name" #partnershipname="ngModel" autocomplete="off" maxlength="128" required [(ngModel)]="clientDataModal.partnershipname" (change)="generateClientCode();checkOnchangefield();" placeholder="Enter name" [ngClass]="{'is-invalid':addClientForm.submitted && partnershipname.invalid }" />
                            <div *ngIf="addClientForm.submitted && partnershipname.invalid" class="invalid-feedback invalid position_kc_step">
                              <div *ngIf="partnershipname.errors.required">
                                Partnership name is required
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Trading as
                        </h6>
                        <div class="col-9">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="tradingName" data-testid="input-trading-name-partnership" #tradingName="ngModel" maxlength="200" autocomplete="off" [(ngModel)]="clientDataModal.tradingName" (change)="checkOnchangefield();" placeholder="Enter trading name" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Salutation<span class="error-text">*</span>
                        </h6>
                        <div class="col-9">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="salutation" data-testid="input-salutation-partnership" autocomplete="off" #salutation="ngModel" maxlength="404" [(ngModel)]="clientDataModal.salutation" placeholder="Enter salutation" required [ngClass]="{'is-invalid':addClientForm.submitted && salutation.invalid }"/>
                             <div *ngIf="addClientForm.submitted && salutation.invalid" class="invalid-feedback invalid position_kc_step">
                              <div *ngIf="salutation.errors.required">
                                Salutation is required
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngTemplateOutlet="commonTextArea; context: { label: 'Mailing name', name: 'mailingName', dataTestid: 'textarea-mailing-name-partnership',
                      maxlength: 500, placeholder: 'Enter mailing name', changeFn: 'checkOnchangefield', required: true }">
                    </ng-container>
                     <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Preferred name
                        </h6>
                        <div class="col-9">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="preferredname" data-testid="input-preferred-name-partnership" autocomplete="off" maxlength="128" (change)="checkOnchangefield();" [(ngModel)]="clientDataModal.preferredname" placeholder="Enter preferred name" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'Formation date', name: 'formationDate', max: maxDate, dataTestid: 'datepkr-formation-date-partnership', changeHandler: checkOnchangefield, maxValueName: 'deRegistrationDate' }">
                    </ng-container>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'Deregistration date', name: 'deRegistrationDate', min: 'formationDate', max: maxDate, dataTestid: 'datepkr-deregistration-date-partnership', changeHandler: checkOnchangefield }">
                    </ng-container>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'Start date', name: 'clientStartDate', max: maxDate, dataTestid: 'datepkr-client-start-date-partnership', changeHandler: checkOnchangefield, maxValueName: 'clientEndDate' }">
                    </ng-container>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'End date', name: 'clientEndDate', min: 'clientStartDate', max: maxDate, dataTestid: 'datepkr-client-end-date-partnership', changeHandler: checkOnchangefield }">
                    </ng-container>
                  </div>
                  <!--Partership Basic end-->
                  <!--SMSF Basic Start-->
                  <div class="createclient-section-row" *ngIf="clientDataModal.entityTypeId == 5">
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Name of SMSF<span class="error-text">*</span>
                        </h6>
                        <div class="col-9">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="smsfName" data-testid="input-smsf-name" #smsfName="ngModel" maxlength="200" autocomplete="off" required [(ngModel)]="clientDataModal.smsfName" (change)="generateClientCode();checkOnchangefield();" placeholder="Enter name" [ngClass]="{'is-invalid':addClientForm.submitted && smsfName.invalid }" />
                            <div *ngIf="addClientForm.submitted && smsfName.invalid" class="invalid-feedback invalid position_kc_step">
                              <div *ngIf="smsfName.errors.required">
                                Name of SMSF is required
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngTemplateOutlet="commonTextArea; context: { label: 'Mailing name', name: 'mailingName', dataTestid: 'textarea-mailing-name-smsf',
                      maxlength: 500, placeholder: 'Enter mailing name', changeFn: 'checkOnchangefield', required: true }">
                    </ng-container>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Salutation<span class="error-text">*</span>
                        </h6>
                        <div class="col-9">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="salutation" data-testid="input-salutation-smsf" autocomplete="off" #salutation="ngModel" maxlength="404" [(ngModel)]="clientDataModal.salutation" placeholder="Enter salutation" required [ngClass]="{'is-invalid':addClientForm.submitted && salutation.invalid }"/>
                             <div *ngIf="addClientForm.submitted && salutation.invalid" class="invalid-feedback invalid position_kc_step">
                              <div *ngIf="salutation.errors.required">
                                Salutation is required
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                     <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Preferred name
                        </h6>
                        <div class="col-9">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="preferredname" data-testid="input-preferred-name-smsf" autocomplete="off" maxlength="128" (change)="checkOnchangefield();" [(ngModel)]="clientDataModal.preferredname" placeholder="Enter preferred name" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'Formation date', name: 'formationDate', max: maxDate, dataTestid: 'datepkr-formationdate-smsf', changeHandler: checkOnchangefield, maxValueName: 'deRegistrationDate' }">
                    </ng-container>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'Deregistration date', name: 'deRegistrationDate', min: 'formationDate', max: maxDate, dataTestid: 'datepkr-deregistration-date-smsf', changeHandler: checkOnchangefield }">
                    </ng-container>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'Start date', name: 'clientStartDate', max: maxDate, dataTestid: 'datepkr-client-start-date-smsf', changeHandler: checkOnchangefield, maxValueName: 'clientEndDate' }">
                    </ng-container>
                    <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                      context: { label: 'End date', name: 'clientEndDate', min: 'clientStartDate', max: maxDate, dataTestid: 'datepkr-client-end-date-smsf', changeHandler: checkOnchangefield }">
                    </ng-container>
                  </div>
                  <!--SMSF Basic end-->
                  <!--Individual Basic end-->
                  <div class="createclient-section-row">
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Resident
                        </h6>
                        <div class="col-3">
                          <div class="cmn-slide-toggle-container">
                            <mat-slide-toggle name="resident" data-testid="tgl-resident" [(ngModel)]="clientDataModal.resident" (change)="checkOnchangefield();" color="primary"></mat-slide-toggle>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="Contact-info-container">
                  <div class="createclient-section-row">
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Client partner<span class="error-text">*</span>
                        </h6>
                        <div class="col-9">
                          <div class="form-select-container">
                            <ng-select [items]="validPartnersList" class="cmn-ngselect"
                                       bindLabel="fullName"
                                       bindValue="userId"
                                       [clearable]="false" name="partnerId" data-testid="drpdwn-partner-name" #partnerId="ngModel"
                                       (change)="checkOnchangefield();" required [ngClass]="{'is-invalid':addClientForm.submitted && partnerId.invalid }"
                                       [(ngModel)]="clientDataModal.partnerId"
                                       placeholder="Select partner">

                              <ng-template ng-option-tmp let-item="item" let-index="index">
                                <span class=""> {{item.fullName}}</span>
                              </ng-template>
                            </ng-select>
                            <div *ngIf="addClientForm.submitted && partnerId.invalid" class="invalid-feedback invalid position_kc_step">
                              <div *ngIf="partnerId.errors.required">
                                Partner is required
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Client  manager
                        </h6>
                        <div class="col-9">
                          <div class="form-select-container">
                            <ng-select [items]="validManagersList" class="cmn-ngselect"
                                       bindLabel="fullName"
                                       bindValue="userId"
                                       [clearable]="true" name="managerId" data-testid="drpdwn-manager-name" #managerId="ngModel"
                                       [(ngModel)]="clientDataModal.managerId" (change)="checkOnchangefield();"
                                       placeholder="Select manager">

                              <ng-template ng-option-tmp let-item="item" let-index="index">
                                <span class=""> {{item.fullName}}</span>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm" *ngIf="officeData.officeViewManagePermission">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Office
                        </h6>
                        <div class="col-9">
                          <div class="form-select-container">
                            <ng-select [items]="officeData.officeList"
                                       class="cmn-ngselect"
                                       bindLabel="name"
                                       bindValue="officeId"
                                       [(ngModel)]="officeData.selectedOfficeId"
                                       [clearable]="true" name="officeSelection"
                                       (clear)="clearOffice()"
                                       placeholder="Select office"
                                       data-testid="drpdwn-office" >
                            </ng-select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Team
                        </h6>
                        <div class="col-9">
                          <div class="form-select-container">
                            <ng-select [items]="teamList" class="cmn-ngselect"
                                       bindLabel="name"
                                       bindValue="teamId"
                                       [clearable]="true" name="teamId" data-testid="drpdwn-team-name" #teamId="ngModel"
                                       [(ngModel)]="clientDataModal.teamId" (change)="checkOnchangefield();"
                                       placeholder="Select Team">

                              <ng-template ng-option-tmp let-item="item" let-index="index">
                                <span class=""> {{item.name}}</span>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Division<span class="error-text">*</span>
                        </h6>
                        <div class="col-9">
                          <div class="form-select-container">
                            <ng-select [items]="divList" class="cmn-ngselect"
                                       bindLabel="divisionName"
                                       bindValue="divisionId"
                                       [clearable]="true" name="divisionId" data-testid="drpdwn-division-name" #divisionId="ngModel"
                                       [(ngModel)]="clientDataModal.divisionId"
                                       (change)="checkOnchangefield();" required [ngClass]="{'is-invalid':addClientForm.submitted && divisionId.invalid }"
                                       placeholder="Select division">

                              <ng-template ng-option-tmp let-item="item" let-index="index">
                                <span class=""> {{item.divisionName}}</span>
                              </ng-template>
                            </ng-select>
                            <div *ngIf="addClientForm.submitted && divisionId.invalid" class="invalid-feedback invalid position_kc_step">
                              <div *ngIf="divisionId.errors.required">
                                Division is required
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Tags
                        </h6>
                        <div class="col-9">
                          <div class="form-multiselect-container" id="strictly-this-dropdown" data-cy="dcyTagsDropdown">
                            <ng-multiselect-dropdown
                              class="cmn-multiselect-dropdown flt-dropdown ellipsis-itemname createclient-tags-dropdown"
                              [placeholder]="'Select tags'" [settings]="tagDropdownSettings" [data]="tagListforClient"
                              [(ngModel)]="selectedClientTags" (ngModelChange)="onTagSelectionChange($event)"
                              [ngModelOptions]="{standalone: true}" (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)"
                              (onDeSelect)="onItemDeSelect($event)" (onDeSelectAll)="onItemDeSelectAll($event)" name="tagsId" data-testid="mslct-tags">
                            </ng-multiselect-dropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm" *ngIf="bpayAlgorithm === 11 && isManageBillerReference">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          Client Bpay ref
                        </h6>
                        <div class="col-9">
                          <div class="form-input-container">
                            <input type="text" inputmode="numeric" class="form-control" name="bpayref" [(ngModel)]="clientDataModal.bPayReference" data-testid="input-bpay-ref-number" autocomplete="off" maxlength="25" placeholder="Enter client Bpay ref" (input)="onBpayRefInput($event)" />
                            <div class="text-danger" *ngIf="bpayRefError">
                              Max allowed length is 25
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h4 class="createclient-section-title">Contact</h4>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center mt-4" *ngFor="let row of emails; let i = index">
                        <!-- Label -->
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Email</h6>
                        <!-- Email Type -->
                        <div class="col-2 form-select-container">
                          <div class="arrowicon normal-form-select-arrow">
                            <select class="form-control"
                                    [(ngModel)]="row.emailTypeId"
                                    name="emailType{{ i }}"
                                    (focus)="onDropdownOpenEmail(row)"
                                    (change)="setEmailPreferredAndImportant(i, row.email)"
                                    data-testid="drpdwn-contacts-email">

                              <option *ngFor="let item of emailTypes"
                                      [ngValue]="item.emailTypeId"
                                      [disabled]="isEmailTypeDisabled(item)">
                                {{ item.emailTypeName }}
                                <span *ngIf="isEmailTypeDisabled(item)"> (Max 5 reached)</span>
                              </option>

                            </select>
                          </div>
                        </div>

                        <!-- Email Input -->
                        <div class="col-4 form-input-container">
                          <input type="email"
                                 class="form-control"
                                 placeholder="Enter email"
                                 [(ngModel)]="row.emailId"
                                 [ngModelOptions]="{ standalone: true }"
                                 [class.is-invalid]="row.touched && row.emailId && !isValidEmail(row.emailId)"
                                 (blur)="onEmailBlur(i, row)"
                                 data-testid="input-contact-email">
                          <div class="invalid-emailphone-feedback position_kc_step"
                               *ngIf="row.emailId && !isValidEmail(row.emailId)">
                            Please enter a valid email
                          </div>
                        </div>

                        <!-- Actions -->
                        <div class="col-3 d-flex align-items-center">
                          <!-- Preferred -->
                          <div class="add-row-start" *ngIf="row.isPreferred">
                            <a (click)="setPreferredEmail(i)" class="cursor-pointer">
                              <img src="../../../../assets/img/ArrowBlueIcon/Preffered blue.svg" alt="imgPreferred" class="width-preffred-icon">
                            </a>
                          </div>
                          <div class="add-row-start" *ngIf="!row.isPreferred">
                            <a (click)="setPreferredEmail(i)" class="cursor-pointer">
                              <img src="../../../../assets/img/ArrowBlueIcon/Preffered.svg" alt="imgPreferred" class="width-preffred-icon">
                            </a>
                          </div>
                          <div class="add-row-start" *ngIf="row.isFavourite">
                            <a (click)="setStartedEmail(i)" class="cursor-pointer">
                              <img src="../../../../assets/img/client/addClientIcons/starYellowIcon.svg" alt="imgstarticon" class="width-star-icon">
                            </a>
                          </div>
                          <div class="add-row-start" *ngIf="!row.isFavourite">
                            <a (click)="setStartedEmail(i)" class="cursor-pointer">
                              <img src="../../../../assets/img/client/addClientIcons/starNormalIcon.svg" alt="imgstarticon" class="width-star-icon">
                            </a>
                          </div>

                          <!-- Remove -->
                          <div class="add-row-btn">
                            <a (click)="removeEmail(i,row)"
                               class="cursor-pointer ml-2"
                               *ngIf="emails.length > 1">
                              <img src="../../../../assets/img/client/filter-icon/delete.svg">
                            </a>
                          </div>

                          <!-- Add -->
                          <button *ngIf="i === emails.length - 1 && emails.length < getMaxAllowedEmails()"
                                  class="cmn-inverse-btn ml-2"
                                  (click)="addEmail(); $event.preventDefault()" data-testid="btn-add-email-alt">
                            + Email
                          </button>

                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm" *ngIf="phones.length > 0">
                      <div class="custom-row align-items-start mt-4" *ngFor="let row of phones; let i = index">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client"> Phone</h6>
                        <div class="col-2 form-select-container">
                          <div class="arrowicon normal-form-select-arrow">
                            <select class="form-control"
                                    [(ngModel)]="row.phoneTypeId"
                                    name="phoneType{{ i }}"
                                    (focus)="onDropdownOpenPhone(row)"
                                    (change)="setPhonePreferredAndImportant(i, row.phone)"
                                    data-testid="drpdwn-phone-type">

                              <option *ngFor="let item of phoneTypes"
                                      [ngValue]="item.phoneTypeId"
                                      [disabled]="isPhoneTypeDisabled(item)">
                                {{ item.phoneTypeName }}
                                <span *ngIf="isPhoneTypeDisabled(item)"> (Max 5 reached)</span>
                              </option>

                            </select>
                          </div>
                        </div>

                        <div class="col-4 phone-number-container d-flex align-items-center">
                          <div class="phone-combined-field d-flex align-items-center">
                            <div class="phone-country-code-container form-select-filter-container settings-temp-tbl-select">
                              <ejs-dropdownlist id="ddlelement"
                                                #samples
                                                [dataSource]="countries"
                                                cssClass="cmn-filter-dropdown"
                                                [query]="query"
                                                [fields]="fields"
                                                [placeholder]="country"
                                                [allowFiltering]="true"
                                                [sortOrder]="sorting"
                                                (change)="onCountryCodeChange(i, $event, row)"
                                                [(ngModel)]="row.countryId"
                                                name="countryId{{ i }}"
                                                data-testid="drpdwn-lst-cntry-cod">

                                <!-- Dropdown list items -->
                                <ng-template #itemTemplate let-data>
                                  {{ data.name }} {{ data.isdCode }}
                                </ng-template>

                                <!-- Selected value -->
                                <ng-template #valueTemplate let-data>
                                  {{ data.isdCode }}
                                </ng-template>

                              </ejs-dropdownlist>
                            </div>
                            <div class="form-input-container phone-number-input-container border-left-input">
                              <input type="text"
                                     class="form-control phone-number-input"
                                     (input)="onPhoneInput(i, $event, row)"
                                     placeholder="Enter phone number"
                                     [(ngModel)]="row.phoneNumber"
                                     [ngModelOptions]="{ standalone: true }"
                                     [class.is-invalid]="row.touched && row.phoneNumber && row.isValidPhone === false"
                                     (blur)="onPhoneBlur(i, row)"
                                     data-testid="input-phn-nmbr">
                              <div class="invalid-emailphone-feedback position_kc_step status-text-truncate"
                                   *ngIf="row.touched && row.phoneNumber && row.isValidPhone === false"
                                   [matTooltip]="row.statusText || 'Please enter a valid phone number'"
                                   matTooltipPosition="left">
                                {{ row.statusText || 'Please enter a valid phone number' }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Actions -->
                        <div class="col-3 d-flex align-items-center">
                          <!-- Preferred -->
                          <div class="add-row-start" *ngIf="row.isPreferred">
                            <a (click)="setPreferredPhone(i)" class="cursor-pointer">
                              <img src="../../../../assets/img/ArrowBlueIcon/Preffered blue.svg" alt="imgPreferred" class="width-preffred-icon">
                            </a>
                          </div>
                          <div class="add-row-start" *ngIf="!row.isPreferred">
                            <a (click)="setPreferredPhone(i)" class="cursor-pointer">
                              <img src="../../../../assets/img/ArrowBlueIcon/Preffered.svg" alt="imgPreferred" class="width-preffred-icon">
                            </a>
                          </div>
                          <div class="add-row-start" *ngIf="row.isFavourite">
                            <a (click)="setStartedPhone(i)" class="cursor-pointer">
                              <img src="../../../../assets/img/client/addClientIcons/starYellowIcon.svg" alt="imgstarticon" class="width-star-icon">
                            </a>
                          </div>
                          <div class="add-row-start" *ngIf="!row.isFavourite">
                            <a (click)="setStartedPhone(i)" class="cursor-pointer">
                              <img src="../../../../assets/img/client/addClientIcons/starNormalIcon.svg" alt="imgstarticon" class="width-star-icon">
                            </a>
                          </div>

                          <!-- Remove -->
                          <div class="add-row-btn">
                            <a (click)="removePhone(i,row)"
                               class="cursor-pointer ml-2"
                               *ngIf="phones.length > 1">
                              <img src="../../../../assets/img/client/filter-icon/delete.svg">
                            </a>
                          </div>

                          <!-- Add -->
                          <button *ngIf="i === phones.length - 1 && phones.length < getMaxAllowedPhones()"
                                  class="cmn-inverse-btn ml-2"
                                  (click)="addPhone(); $event.preventDefault()" data-testid="btn-add-phn-nmbr">
                            + Phone
                          </button>

                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm pt-1">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                          LinkedIn id
                        </h6>
                        <div class="col-4">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="linkedinprofileID" data-testid="input-linkedin-profile" autocomplete="off"
                                   (change)="ValidateLinkedinUrl();$event.preventDefault();" [(ngModel)]="clientDataModal.linkedinprofileID" (change)="checkOnchangefield();"
                                   #linkWithPattern="ngModel"
                                   placeholder="Enter LinkedIn profile id" />
                            <div *ngIf="clientDataModal.linkedinprofileID !='' && !ValidateLinked" class="invalid-feedback invalid position_kc_step">Please enter a valid LinkedIn url</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="physical-info-container">
                  <h4 class="createclient-section-title">Address</h4>
                  <div *ngFor="let addressSet of addressSets; let i = index" class="createclient-section-row">
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Type</h6>
                        <div class="col-6">
                          <div class="form-select-container">
                            <ng-select [items]="addressTypeList[i]" [disabled]="addressSet.addressPoolMappingId > 0" class="cmn-ngselect" data-testid="drpdwn-address-type"
                                       bindLabel="addressTypeName"
                                       bindValue="addressTypeId"
                                       name="type{{i}}"
                                       [clearable]="true"
                                       (clear)="clearAddressType(addressSet)"
                                       [(ngModel)]="addressSet.addressTypeId"
                                       placeholder="Select type">
                            </ng-select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Care of</h6>
                        <div class="col-6">
                          <div class="form-input-container">
                            <input type="text" name="careof{{i}}" class="form-control" autocomplete="off" [(ngModel)]="addressSet.careof" (ngModelChange)="onAddressCareOfChange($event, i, 'client')" placeholder="Enter care of" data-testid="input-address-careof-alt"/>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Address</h6>
                        <div class="col-6">
                          <div class="form-select-container client-address-cmd client-address-footer-content Client-address-input-cmd form-select-address-container form-address-input-cmd form-select-address-shadow">
                            <ng-select class="cmn-ngselect" [items]="addressSet.fullAddressList" [disabled]="!addressSet.addressTypeId || addressSet.addressPoolMappingId > 0"
                                       bindLabel="addressLine" bindValue="addressPoolId" notFoundText='No address found' [virtualScroll]="true"
                                       [(ngModel)]="addressSet.addressPoolId" (focus)="onAddClientClear(i)" (clear)="onAddClientClear(i)" (ngModelChange)="checkAddressPool(addressSet)"
                                       [typeahead]="addressSet.addressInput$" typeToSearchText="Please enter 3 or more characters" (search)="onAddressSearch($event, i)" placeholder="Select address"
                                       name="fullAddress{{i}}" data-testid="drpdwn-addrs-ln">
                              <ng-template ng-footer-tmp>
                                <div class="create-new" (click)="createAddressPopupOpen(i,'client')">+ Create address</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-3" *ngIf="addressSet.addressPoolId && addressSet.addressTypeId">
                          <div class="d-flex align-items-center">
                            <div class="add-row-start" *ngIf="addressSets[i].isFavorite">
                              <a data-testid="lnk-favorite-address" class="cursor-pointer">
                                <img src="../../../../assets/img/client/addClientIcons/starYellowIcon.svg" class="" />
                              </a>
                            </div>
                            <div class="add-row-start" *ngIf="!addressSets[i].isFavorite">
                              <a data-testid="lnk-unfavorite-address" class="cursor-pointer" (click)="setAddressAsFavorite(i)">
                                <img src="../../../../assets/img/client/addClientIcons/starNormalIcon.svg" class="" />
                              </a>
                            </div>
                            <div class="add-row-btn">
                              <button type="button" [disabled]="activateButton" class="cmn-inverse-btn" mat-button (click)="addAddressSet()" *ngIf="i == 0 && addressSets.length < addressTypes.length">+ Address</button>
                              <a class="cursor-pointer" data-testid="lnk-remove-address" (click)="removeAddress(i)">
                                <img src="../../../../assets/img/client/filter-icon/delete.svg" class="" />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--address ends-->
                <div class="custom-field-container">
                  <h4 class="createclient-section-title" *ngIf="cfqcitem.length > 0">Custom fields </h4>
                  <div class="customs_fields_section" *ngFor="let cf of cfqcitem; let i = index;">

                    <div class="createclient-section-row">
                      <div class="form-group form-group-sm">
                        <div class="custom-row" [ngClass]="{'align-items-center':cf.fieldType!='Checkbox'}">
                          <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client" *ngIf="cf.fieldType=='Header' && i == 0">
                            {{cf.fieldLabel}} Custom fields
                          </h6>
                          <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client header-label" *ngIf="cf.fieldType=='Header' && i != 0">
                            {{cf.fieldLabel}}
                          </h6>
                          <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client" *ngIf="cf.fieldType!='Header'">
                            {{cf.fieldLabel}} <span *ngIf="cf.helpText" class="ml-1 custom_fields_info" matTooltipClass="cmn-tooltip-template cmn-tooltip-template-width" matTooltip="{{cf.helpText}}">
                              <img src="../../../../assets/img/info-blue.svg" width="13px" loading="lazy" />
                            </span>
                          </h6>
                          <div class="col-5" [ngClass]="{'col-5':cf.fieldType!='Checkbox','col-9':cf.fieldType=='Checkbox'}">
                            <div class="form-input-container" *ngIf="cf.fieldType=='Text'">
                              <input type="text"
                                     class="form-control"
                                     [placeholder]="cf.placeHolder" data-testid="input-custom-text"
                                     #value="ngModel"
                                     [(ngModel)]="cf.value"
                                     name="value-{{i}}"
                                     autocomplete="off"
                                     maxlength="50"
                                     [readonly]="cf.isReadOnly" />
                            </div>
                            <div class="form-select-container" *ngIf="cf.fieldType=='Dropdown List'">
                              <ng-select class="cmn-ngselect wthout-ellipsis-option"
                                         name="cfdropdown-{{i}}" [placeholder]="cf.placeHolder" bindLabel="dropvalue" bindValue="dropvalueId" [items]="cf.cfdropdown" (clear)="onClearCustomFieldDropdown(cf)"
                                         #cfdropdown="ngModel" [(ngModel)]="cf.value" [clearable]="cf.value">
                                <ng-template ng-label-tmp let-item="item">
                                  <span [ngClass]="{'ng-select-custom-placeholder': !cf.value}">
                                    {{item.dropvalue}}
                                  </span>
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item" let-index="index">
                                  <span [ngClass]="{'is-option-hidden': item.isHidden}"> {{item.dropvalue}}</span>
                                </ng-template>
                              </ng-select>
                            </div>
                            <div *ngIf="cf.fieldType=='Checkbox'" class="d-flex flex-wrap customfields-chk-list">
                              <div class="cmn-checkbox mr-3 mb-2" *ngFor="let item of cf.cfdropdown; let j=index;">
                                <input type="checkbox" class="" id="{{item.dropvalueId}}" name="cfchkbox-{{i}}" data-testid="chk-custom-check" [(ngModel)]="item.status" [ngModelOptions]="{standalone: true}"
                                       (change)="chkqccustomfield($event,item.dropvalueId,i,j);" />
                                <label class="cmn-checkbox-text" for="cfchkbox-{{i}}">
                                  <span class="checkbox-square"></span>
                                  {{item.dropvalue}}
                                </label>
                              </div>
                            </div>
                            <div class="form-input-container" *ngIf="cf.fieldType=='Number'">
                              <input type="number"
                                     class="form-control"
                                     #value="ngModel"
                                     [(ngModel)]="cf.value"
                                     name="value-{{i}}"
                                     autocomplete="off"
                                     [placeholder]="cf.placeHolder" data-testid="input-custom-number"
                                     [readonly]="cf.isReadOnly"
                                     onkeypress="javascript: return event.target.value.length > 15 ? false : true"
                                     onkeydown="javascript: return event.keyCode == 69 ? false : true" />
                            </div>
                            <div class="form-input-container" *ngIf="cf.fieldType=='Link'">
                              <input type="url" class="form-control" #value="ngModel" [(ngModel)]="cf.value" name="value-{{i}}" autocomplete="off" [placeholder]="cf.placeHolder" [readonly]="cf.isReadOnly"
                                     pattern="https?:\/\/(?:www\.)?[a-zA-Z0-9\-\.]+\.[a-z]{2,}(\/\S*)?"
                                     (blur)="value.control.markAsTouched()" />
                              <div *ngIf="value.invalid && value.touched" class="text-danger">
                                <div *ngIf="value.errors?.['pattern']">Enter a valid URL (e.g., https://example.com).</div>
                              </div>
                            </div>
                            <div class="form-datepicker-container cmn-material-datepicker" *ngIf="cf.fieldType=='Date'">
                              <mat-form-field floatLabel="never" appearance="standard">
                                <input class="cmn-mat-dtpicker-input" matInput
                                       #value="ngModel"
                                       data-testid="input-custom-date"
                                       [(ngModel)]="cf.value" [matDatepicker]="CfDatepicker"
                                       name="value-{{i}}" autocomplete="off" placeholder="dd/mm/yyyy" [disabled]="cf.isReadOnly != 'readonly' ? false : true">
                                <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" matIconSuffix [for]="CfDatepicker"></mat-datepicker-toggle>
                                <mat-datepicker panelClass="cmn-datepicker-ui"
                                                #CfDatepicker></mat-datepicker>
                                <mat-error class="cmn-material-datepicker-errormsg">
                                  Please enter the date in dd/mm/yyyy
                                </mat-error>
                              </mat-form-field>
                            </div>
                            <div class="form-select-container" *ngIf="cf.fieldType=='User'">
                              <div class="d-flex justify-content-start" *ngIf="!cf._isVisibleInput; else CfUserDropdown">
                                <div *ngFor="let item of cf?._userInfo|slice:0:2" class="profile-round-items">
                                  <div class="profile_name_cicrle" [ngStyle]="{'background-color': item.backgroundColor, 'color': item.textColor}"
                                       matTooltipClass="cmn-tooltip-template" [matTooltip]="item.fullName">
                                    {{ item.shortName }}
                                  </div>
                                </div>
                                <div class="seemore-assignee-circle" *ngIf="cf?._userInfo?.length>2" [matMenuTriggerFor]="menus"
                                     #menuTrigger="matMenuTrigger" (mouseenter)="menuTrigger.openMenu()" (mouseleave)="menuTrigger.closeMenu()">
                                  +{{cf?._userInfo?.length-2}}
                                </div>

                                <div class="addassignee-cicrcle-btn">
                                  <button type="button" mat-button
                                          class="cmn-border-btn" (click)="showCFUserDropdown(cf)" data-testid="btn-show-usr-drpdwn">
                                    +
                                  </button>
                                </div>
                                <mat-menu #menus="matMenu" [overlapTrigger]="false" [hasBackdrop]="false">
                                  <div class="assignee-tooltip-items">
                                    <div *ngFor="let item of cf?._userInfo | slice:2" class="assignee-tooltip-items-name">
                                      {{item.fullName}}
                                    </div>
                                  </div>
                                </mat-menu>
                              </div>

                              <ng-template #CfUserDropdown>
                                <div class="form-multiselect-container addnew-assignee-input">
                                  <ng-multiselect-dropdown class="cmn-multiselect-dropdown flt-dropdown ellipsis-itemname"
                                                           [placeholder]="'Select'" [settings]="cfUserDropdownSetting" [ngModelOptions]="{standalone: true}"
                                                           [data]="cf.cfdropdown"
                                                           [(ngModel)]="cf.value" (onDropDownClose)="hideCFUserDropdown(cf)"
                                                           (ngModelChange)="onCFUserDropdownChange(cf)" 
                                                           data-testid="mslct-custom-user">
                                  </ng-multiselect-dropdown>
                                </div>
                              </ng-template>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Basic End-->
              <!-- Link start-->
              <div class="link-stepper-content">
                <form #addcontactForm="ngForm" appFocusOnErrorField (ngSubmit)="addContactconfirm(addcontactForm)" novalidate>
                  <div *ngIf="currentPage == 3">
                    <div class="link-stepper-contact-list" *ngIf="!contactHide">
                      <div class="text-right">
                        <button type="button" mat-button class="cmn-inverse-btn" (click)="contactInform(addcontactForm)" data-testid="btn-create-new-contact">
                          Create new contact
                        </button>
                      </div>
                      <div class="contact-list cmn-table-design">
                        <table class="table table-borderless" data-testid="tbl-contact-list">
                          <thead>
                            <tr>
                              <th scope="col">Contact name</th>
                              <th scope="col">Email address</th>
                              <th scope="col">DOB</th>
                              <th scope="col">Contact type</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let item of contactTable; let i = index;">
                              <td hidden>{{item.ContactId}}</td>
                              <td>
                                <div class="cmn-autocomplete-input-container">
                                  <ng-autocomplete [data]="contactdata"
                                                   [searchKeyword]="keyword"
                                                   placeholder="Add contact person"
                                                   (selected)='onAddContactnew($event,i)'
                                                   (inputChanged)='getServerResponse($event)'
                                                   (inputFocused)='onFocusedone($event)'
                                                   [itemTemplate]="itemTemplate"
                                                   (inputCleared)="searchCleared()"
                                                   [notFoundTemplate]="notFoundTemplate"
                                                   [debounceTime]="600"
                                                   [isLoading]="isLoadingResult"
                                                   [minQueryLength]="2"
                                                   [(ngModel)]="contactTable[i].Contact"
                                                   [initialValue]="contactTable[i].Contact"
                                                   name="name-{{i}}"
                                                   class="autocomplete-contact"
                                                   data-testid="autocmplt-contact"
                                                   >
                                  </ng-autocomplete>

                                  <ng-template #itemTemplate let-item>
                                    <a href="javascript:void(0)">
                                      <span [innerHTML]="item.name" style="font-weight:500"> </span>
                                    </a>
                                  </ng-template>

                                  <ng-template #notFoundTemplate let-notFound>
                                    {{errorMsg}}
                                  </ng-template>
                                </div>
                              </td>
                              <td>
                                {{item.Emailaddress}}
                              </td>
                              <td>{{item?.DateOfBirth ? (item.DateOfBirth | date:'dd/MM/yyyy') : ''}}</td>
                              <td>
                                <div class="form-select-container">
                                  <select class="form-control" name="{{i}}" data-testid="drpdwn-contact-type" style="width:100% !important;font-style:normal !important;color:#333333 !important" [(ngModel)]="item.ContactType">
                                    <option value="0" disabled>Select contact type</option>
                                    <option value="1">Adviser</option>
                                    <option value="2">Accountant</option>
                                    <option value="3">Auditor</option>
                                    <option value="4">Bookkeeper</option>
                                    <option value="5">Lawyer</option>
                                    <option value="6">Real estate agent</option>
                                    <option value="7">Stockbroker</option>
                                    <option value="8">Tax agent</option>
                                  </select>
                                </div>
                              </td>
                              <td>
                                <div class="remve-contact-action">
                                  <a (click)="RemoveContact(item.ContactId)" data-testid="lnk-remove-contact">
                                    <img src="../../../../assets/img/client/client-icon/close_button.svg" />
                                  </a>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td colspan="6">
                                <button mat-button class="cmn-inverse-btn" (click)="AddContactRow()" data-testid="btn-add-contact-row">
                                  +Add row
                                </button>
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                    <div class="contact-content-scroll" *ngIf="contactHide">
                      <h4 class="createclient-section-title">Contact information</h4>
                      <div class="basic-info-container">
                        <h4 class="createclient-section-title">Basic info</h4>
                        <div class="createclient-section-row">
                          <div class="form-group form-group-sm">
                            <div class="custom-row align-items-center">
                              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Title</h6>
                              <div class="col-3">
                                <div class="form-select-container">
                                  <ng-select [items]="titleList" class="cmn-ngselect" data-testid="drpdwn-salutation-contact"
                                             bindLabel="title"
                                             bindValue="title"
                                             [clearable]="true" id="title" name="title" #title="ngModel"
                                             placeholder="Select title" (change)="checkOnchangefield();" [(ngModel)]="contactDataModal.title">

                                    <ng-template ng-option-tmp let-item="item" let-index="index">
                                       <span class=""> {{item.title.length > 15 ? (item.title| slice:0:15) + '..' : item.title}}</span>
                                    </ng-template>
                                  </ng-select>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group form-group-sm">
                            <div class="custom-row align-items-center">
                              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Name<span class="error-text">*</span></h6>
                              <div class="col-3">
                                <div class="form-input-container">
                                  <input type="text" class="form-control" maxlength="50" name="firstname" data-testid="input-first-name-contact" #firstName1="ngModel" autocomplete="off" (change)="checkContactOnchangefield();" [(ngModel)]="contactDataModal.firstName" placeholder="Enter first name*" required [ngClass]="{'is-invalid':addcontactForm.submitted && firstName1.invalid }" />
                                  <div *ngIf="addcontactForm.submitted && firstName1.invalid" class="invalid-feedback invalid position_kc_step">
                                    <div *ngIf="firstName1.errors.required">
                                      First name is required
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-3">
                                <div class="form-input-container">
                                  <input type="text" class="form-control" autocomplete="off" name="middleName" data-testid="input-middle-name-contact" (change)="checkContactOnchangefield();" [(ngModel)]="contactDataModal.middleName" placeholder="Enter middle name" />
                                </div>
                              </div>
                              <div class="col-3">
                                <div class="form-input-container">
                                  <input type="text" class="form-control" autocomplete="off" name="lastname" data-testid="input-last-name-contact" #lastname1="ngModel" (change)="checkContactOnchangefield();" [(ngModel)]="contactDataModal.lastname" placeholder="Enter last name*" required [ngClass]="{'is-invalid':addcontactForm.submitted && lastname1.invalid }" />
                                  <div *ngIf="addcontactForm.submitted && lastname1.invalid" class="invalid-feedback invalid position_kc_step">
                                    <div *ngIf="lastname1.errors.required">
                                      Last name is required
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group form-group-sm">
                            <div class="custom-row align-items-center">
                              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                                Salutation<span class="error-text">*</span>
                              </h6>
                              <div class="col-9">
                                <div class="form-input-container">
                                  <input type="text" class="form-control" name="salutation" data-testid="input-salutation-contact" autocomplete="off" maxlength="128" [(ngModel)]="contactDataModal.salutation" placeholder="Enter salutation" required [ngClass]="{'is-invalid':addcontactForm.submitted && salutation.invalid }"/>
                                  <div *ngIf="addcontactForm.submitted && salutation.invalid" class="invalid-feedback invalid position_kc_step">
                                    <div *ngIf="salutation.errors.required">
                                      Salutation is required
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group form-group-sm">
                            <div class="custom-row align-items-center">
                              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Preferred name</h6>
                              <div class="col-3">
                                <div class="form-input-container">
                                  <input type="text"
                                         class="form-control" name="preferredname" data-testid="input-preferred-name-contact" (change)="checkContactOnchangefield();" [(ngModel)]="contactDataModal.preferredname"
                                         placeholder="Enter preferred name" autocomplete="off" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group form-group-sm">
                            <div class="custom-row align-items-center">
                              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Date of birth</h6>
                              <div class="col-3">
                                <div class="form-datepicker-container cmn-material-datepicker">
                                  <mat-form-field floatLabel="never" appearance="standard">
                                    <input class="cmn-mat-dtpicker-input" matInput
                                           [max]='maxDate'
                                           #dateOfBirth="ngModel"
                                           data-cy="dcyDOBContact"
                                           (dateChange)="checkContactOnchangefield()"
                                           [(ngModel)]="contactDataModal.dateOfBirth" [matDatepicker]="ccntctdateofbirthDatepicker"
                                           name="dateOfBirth" autocomplete="off" placeholder="dd/mm/yyyy">
                                    <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" matIconSuffix [for]="ccntctdateofbirthDatepicker"></mat-datepicker-toggle>
                                    <mat-datepicker panelClass="cmn-datepicker-ui"
                                                    #ccntctdateofbirthDatepicker></mat-datepicker>
                                    <mat-error class="cmn-material-datepicker-errormsg" *ngIf="!dateOfBirth.hasError('matDatepickerMax')">
                                      Please enter the date in dd/mm/yyyy
                                    </mat-error>
                                    <mat-error class="cmn-material-datepicker-errormsg" *ngIf="dateOfBirth.hasError('matDatepickerMax')">
                                      Please enter a valid Date of birth
                                    </mat-error>
                                  </mat-form-field>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group form-group-sm">
                            <div class="custom-row align-items-center">
                              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Place Of birth</h6>
                              <div class="col-3">
                                <div class="form-input-container">
                                  <input type="text"
                                         class="form-control" name="placeOfBirth" maxlength="128" data-testid="input-place-of-birth-contact" (change)="checkContactOnchangefield();" [(ngModel)]="contactDataModal.placeOfBirth"
                                         placeholder="Enter place of birth" autocomplete="off" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group form-group-sm">
                            <div class="custom-row align-items-center">
                              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Gender</h6>
                              <div class="col-3">
                                <div class="normal-form-select-arrow">
                                  <select class="form-control" name="gender" data-testid="drpdwn-gender-contact" (change)="checkContactOnchangefield();" [(ngModel)]="contactDataModal.gender">
                                    <option value="undefined" selected="selected" disabled>Select gender</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Unspecified">Unspecified</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="Contact-info-container">
                        <h4 class="createclient-section-title">Contact</h4>
                        <div class="createclient-section-row">
                          <div class="form-group form-group-sm">
                            <div class="custom-row align-items-center">
                              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Email </h6>
                              <div class="col-2">
                                <div class="normal-form-select-arrow">
                                  <select class="form-control" name="emailoption4" data-testid="drpdwn-email-option-contact" (change)="checkContactOnchangefield();" [(ngModel)]="emailoption4">
                                    <!--<option value=undefined disabled>Type of mail</option>-->
                                    <option value="1" selected>Personal</option>
                                    <option value="2">Work</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="form-input-container">
                                  <input type="email" placeholder="Enter email" name="emailWithPattern1" data-testid="input-email-contact-one"
                                         autocomplete="off" #emailWithPattern1="ngModel"
                                         [(ngModel)]="emailstring4" (change)="checkContactOnchangefield();" class="form-control" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" [ngClass]="{'is-invalid':addcontactForm.submitted && emailWithPattern1.invalid }" />
                                  <div *ngIf="emailWithPattern1.touched" class="invalid-feedback invalid position_kc_step">
                                    <p *ngIf="emailWithPattern1.errors?.pattern">
                                      Please enter a valid email
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div class="col-3">
                                <div class="d-flex align-items-center">
                                  <div class="add-row-start" *ngIf="emailbookmark4">
                                    <a (click)="starValuefour();" class="cursor-pointer" data-testid="lnk-star-contact-one">
                                      <img src="../../../../assets/img/client/addClientIcons/starYellowIcon.svg" />
                                    </a>
                                  </div>
                                  <div class="add-row-start" *ngIf="!emailbookmark4">
                                    <a (click)="starValuefour();" data-testid="lnk-star-contact-two" class="cursor-pointer">
                                      <img src="../../../../assets/img/client/addClientIcons/starNormalIcon.svg" />
                                    </a>
                                  </div>
                                  <div class="add-row-btn" *ngIf="workEmailCount2 < 3">
                                    <button class="cmn-inverse-btn" mat-button (click)="AddEmail1();$event.preventDefault();" data-testid="btn-add-email-contact">+ Email</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="custom-row align-items-center mt-3" *ngIf="workEmailCount2 > 1">
                              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Email </h6>
                              <div class="col-2">
                                <div class="normal-form-select-arrow">
                                  <select class="form-control" name="emailoption5" data-testid="drpdwn-email-contact" (change)="checkContactOnchangefield();" [(ngModel)]="emailoption5">
                                    <option value="1" selected>Personal</option>
                                    <option value="2">Work</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="form-input-container">
                                  <input type="email" placeholder="Enter email" data-testid="input-email-contact-two" autocomplete="off" name="emailWithPattern2"
                                         #emailWithPattern2="ngModel"
                                         [(ngModel)]="emailstring5" (change)="checkContactOnchangefield();" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" class="form-control" [ngClass]="{'is-invalid':addcontactForm.submitted && emailWithPattern2.invalid }" />

                                  <div *ngIf="emailWithPattern2.touched" class="invalid-feedback invalid position_kc_step">
                                    <p *ngIf="emailWithPattern2.errors?.pattern">
                                      Please enter a valid email
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div class="col-3">
                                <div class="d-flex align-items-center">
                                  <div class="add-row-start" *ngIf="emailbookmark5">
                                    <a (click)="starValuefive();" class="cursor-pointer" data-testid="lnk-star-contact-three">
                                      <img src="../../../../assets/img/client/addClientIcons/starYellowIcon.svg" />
                                    </a>
                                  </div>
                                  <div class="add-row-start" *ngIf="!emailbookmark5">
                                    <a (click)="starValuefive();" class="cursor-pointer" data-testid="lnk-star-contact-four">
                                      <img src="../../../../assets/img/client/addClientIcons/starNormalIcon.svg" />
                                    </a>
                                  </div>
                                  <div class="add-row-btn">
                                    <a (click)="RemoveEmailfive();" class="cursor-pointer" data-testid="lnk-remove-contact-two">
                                      <img src="../../../../assets/img/client/filter-icon/delete.svg" />
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="custom-row align-items-center mt-2" *ngIf="workEmailCount2 > 2">
                              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Email </h6>
                              <div class="col-2">
                                <div class="normal-form-select-arrow">
                                  <select class="form-control" name="emailoption6" data-testid="drpdwn-email-contact-two" [(ngModel)]="emailoption6">
                                    <option value="1" selected>Personal</option>
                                    <option value="2">Work</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="form-input-container">
                                  <input type="email" placeholder="Enter email" autocomplete="off"
                                         name="emailWithPattern3" #emailWithPattern3="ngModel" (change)="checkContactOnchangefield();" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                         [(ngModel)]="emailstring6" class="form-control" [ngClass]="{'is-invalid':addcontactForm.submitted && emailWithPattern3.invalid }" 
                                         data-testid="input-email-contact-three"/>
                                  <div *ngIf="emailWithPattern3.touched" class="invalid-feedback invalid position_kc_step">
                                    <p *ngIf="emailWithPattern3.errors?.pattern">
                                      Please enter a valid email
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div class="col-3">
                                <div class="d-flex align-items-center">
                                  <div class="add-row-start" *ngIf="emailbookmark6">
                                    <a (click)="starValuesix();" class="cursor-pointer" data-testid="lnk-star-contact-five">
                                      <img src="../../../../assets/img/client/addClientIcons/starYellowIcon.svg" />
                                    </a>
                                  </div>
                                  <div class="add-row-start" *ngIf="!emailbookmark6">
                                    <a (click)="starValuesix();" class="cursor-pointer" data-testid="lnk-star-contact-six">
                                      <img src="../../../../assets/img/client/addClientIcons/starNormalIcon.svg" />
                                    </a>
                                  </div>
                                  <div class="add-row-btn">
                                    <a (click)="RemoveEmailsix();" class="cursor-pointer" data-testid="lnk-remove-contact-three">
                                      <img src="../../../../assets/img/client/filter-icon/delete.svg" />
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group form-group-sm">
                            <div class="custom-row align-items-center">
                              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Phone </h6>
                              <div class="col-2">
                                <div class="normal-form-select-arrow">
                                  <select class="form-control" name="phoneoption4" [(ngModel)]="phoneoption4" data-testid="drpdwn-phone-option-contact">
                                    <option value="1" selected>Home</option>
                                    <option value="2">Work</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="form-input-container">
                                  <input type="text" placeholder="Enter phone" autocomplete="off" mask="0000 000 000" name="phoneWithPattern1"
                                         #phoneWithPattern1="ngModel" (change)="checkContactOnchangefield();"
                                         [(ngModel)]="phonestring4" (keyup)="onPhoneValidatecontact();$event.preventDefault();" class="form-control" [ngClass]="{'is-invalid':addcontactForm.submitted && phoneWithPattern1.invalid }" data-testid="input-phone-contact"/>
                                  <div *ngIf="phonestring4 !='' && _phone4Validator" class="invalid-feedback invalid position_kc_step">Please enter valid phone number</div>

                                </div>
                              </div>
                              <div class="col-3">
                                <div class="d-flex align-items-center">
                                  <div class="add-row-start" *ngIf="phonebookmark4">
                                    <a (click)="starPhoneAddOfourValue();" class="cursor-pointer" data-testid="lnk-star-phone-contact">
                                      <img src="../../../../assets/img/client/addClientIcons/starYellowIcon.svg" />
                                    </a>
                                  </div>
                                  <div class="add-row-start" *ngIf="!phonebookmark4">
                                    <a (click)="starPhoneAddOfourValue();" class="cursor-pointer" data-testid="lnk-star-phone-contact">
                                      <img src="../../../../assets/img/client/addClientIcons/starNormalIcon.svg" />
                                    </a>
                                  </div>
                                  <div class="add-row-btn" *ngIf="homePhoneCount2 < 3">
                                    <button class="cmn-inverse-btn" mat-button (click)="AddPhone1();$event.preventDefault();" data-testid="btn-add-phone">+ Phone</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="custom-row align-items-center mt-3" *ngIf="homePhoneCount2 > 1">
                              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Phone </h6>
                              <div class="col-2">
                                <div class="normal-form-select-arrow">
                                  <select class="form-control" name="phoneoption5" [(ngModel)]="phoneoption5" data-testid="drpdwn-phone-option-contact-five">
                                    <option value="1" selected>Home</option>
                                    <option value="2">Work</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="form-input-container">
                                  <input type="text" placeholder="Enter phone" autocomplete="off" mask="0000 000 000"
                                         #validPhoneNumber3="ngModel" (change)="checkContactOnchangefield();" name="phonestring5" [(ngModel)]="phonestring5" class="form-control" (keyup)="onPhoneValidatecontact();$event.preventDefault();" [ngClass]="{'is-invalid':addcontactForm.submitted && validPhoneNumber3.invalid }" data-testid="input-phone-contact-five"/>
                                  <div *ngIf="phonestring5 !='' && _phone5Validator" class="invalid-feedback invalid position_kc_step">Please enter valid phone number</div>
                                </div>
                              </div>
                              <div class="col-3">
                                <div class="d-flex align-items-center">
                                  <div class="add-row-start" *ngIf="phonebookmark5">
                                    <a (click)="starPhoneAddfiveValue();" class="cursor-pointer" data-testid="lnk-star-phone-contact-five">
                                      <img src="../../../../assets/img/client/addClientIcons/starYellowIcon.svg" />
                                    </a>
                                  </div>
                                  <div class="add-row-start" *ngIf="!phonebookmark5">
                                    <a (click)="starPhoneAddfiveValue();" class="cursor-pointer" data-testid="lnk-star-phone-contact-five">
                                      <img src="../../../../assets/img/client/addClientIcons/starNormalIcon.svg" />
                                    </a>
                                  </div>
                                  <div class="add-row-btn">
                                    <a (click)="Removephonefive()" data-testid="lnk-remove-phone-contact-five">
                                      <img src="../../../../assets/img/client/filter-icon/delete.svg" />
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="custom-row align-items-center mt-2" *ngIf="homePhoneCount2 > 2">
                              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Phone </h6>
                              <div class="col-2">
                                <div class="normal-form-select-arrow">
                                  <select class="form-control" name="phoneoption6" [(ngModel)]="phoneoption6" data-testid="drpdwn-phone-option-contact-six">
                                    <option value="1" selected>Home</option>
                                    <option value="2">Work</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="form-input-container">
                                  <input type="text" placeholder="Enter phone" autocomplete="off" mask="0000 000 000" #validPhoneNumber4="ngModel" name="phonestring6" [(ngModel)]="phonestring6" (keyup)="onPhoneValidatecontact();$event.preventDefault();" class="form-control" [ngClass]="{'is-invalid':addcontactForm.submitted && validPhoneNumber4.invalid }" data-testid="input-phone-contact-six"/>
                                  <div *ngIf="phonestring6 !='' && _phone6Validator" class="invalid-feedback invalid position_kc_step">Please enter valid phone number</div>
                                </div>
                              </div>
                              <div class="col-3">
                                <div class="d-flex align-items-center">
                                  <div class="add-row-start" *ngIf="phonebookmark6">
                                    <a (click)="starPhoneAdsixValue();" class="cursor-pointer" data-testid="lnk-star-phone-contact-six">
                                      <img src="../../../../assets/img/client/addClientIcons/starYellowIcon.svg" />
                                    </a>
                                  </div>
                                  <div class="add-row-start" *ngIf="!phonebookmark6">
                                    <a (click)="starPhoneAdsixValue();" class="cursor-pointer" data-testid="lnk-star-phone-contact-six-alt">
                                      <img src="../../../../assets/img/client/addClientIcons/starNormalIcon.svg" />
                                    </a>
                                  </div>
                                  <div class="add-row-btn">
                                    <a (click)="Removephonesix()" data-testid="lnk-remove-phone-contact-six">
                                      <img src="../../../../assets/img/client/filter-icon/delete.svg" />
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group form-group-sm">
                            <div class="custom-row align-items-center">
                              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">LinkedIn profile id</h6>
                              <div class="col-4">
                                <div class="form-input-container">
                                  <input type="text" class="form-control" placeholder="Enter LinkedIn profile id" (change)="ValidateContactLinkedinUrl();$event.preventDefault();"
                                         name="linkedinprofileID" [(ngModel)]="contactDataModal.linkedinprofileID" autocomplete="off" data-testid="input-linkedin-profile-id"/>
                                  <div *ngIf="contactDataModal.linkedinprofileID !='' && !ValidateContactLinked" class="invalid-feedback invalid">Please enter valid LinkedIn url</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>


                      <div class="physical-info-container">
                        <h4 class="createclient-section-title">Address</h4>
                        <div *ngFor="let aSet of addressSetsContact; let i = index" class="createclient-section-row">
                          <div class="form-group form-group-sm">
                            <div class="custom-row align-items-center">
                              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Type</h6>
                              <div class="col-6">
                                <div class="form-select-container">
                                  <ng-select [items]="addressTypeListContact[i]" [disabled]="aSet.addressPoolMappingId > 0" class="cmn-ngselect" data-testid="drpdwn-address-type-contact"
                                             bindLabel="addressTypeName"
                                             bindValue="addressTypeId"
                                             name="type_{{i}}"
                                             [clearable]="true"
                                             (clear)="clearAddressTypeContact(aSet)"
                                             [(ngModel)]="aSet.addressTypeId"
                                             placeholder="Select type">
                                  </ng-select>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="form-group form-group-sm">
                            <div class="custom-row align-items-center">
                              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Care of</h6>
                              <div class="col-6">
                                <div class="form-input-container">
                                  <input type="text" name="careof_{{i}}" [disabled]="aSet.addressPoolMappingId > 0" class="form-control" autocomplete="off" [(ngModel)]="aSet.careof" data-testid="input-address-careof" placeholder="Enter care of" />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="form-group form-group-sm">
                            <div class="custom-row align-items-center">
                              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Address</h6>
                              <div class="col-6">
                                <div class="form-select-container client-address-cmd client-address-footer-content Client-address-input-cmd form-select-address-container form-address-input-cmd form-select-address-shadow">
                                  <ng-select class="cmn-ngselect" [items]="aSet.fullAddressList" [disabled]="!aSet.addressTypeId || aSet.addressPoolMappingId > 0"
                                             bindLabel="addressLine" bindValue="addressPoolId" notFoundText='No address found'
                                             [(ngModel)]="aSet.addressPoolId" (ngModelChange)="checkAddressPoolContact(aSet)"
                                             [typeahead]="aSet.addressInput$" (focus)="onAddContactClear(i)" (clear)="onAddContactClear(i)" typeToSearchText="Please enter 3 or more characters" (search)="onAddressSearchContact($event, i)" placeholder="Select address"
                                             name="fullAddress_{{i}}" data-testid="drpdwn-addrs-contact">
                                    <ng-template ng-footer-tmp>
                                      <div class="create-new" (click)="createAddressPopupOpen(i,'contact')" data-testid="lnk-create-address-contact">
                                        +Create address
                                      </div>
                                    </ng-template>
                                  </ng-select>
                                </div>
                              </div>
                              <div class="col-3" *ngIf="aSet.addressPoolId && aSet.addressTypeId">
                                <div class="d-flex align-items-center">
                                  <div class="add-row-start" *ngIf="aSet.isFavorite">
                                    <a data-testid="lnk-favorite-address-contact" class="cursor-pointer">
                                      <img src="../../../../assets/img/client/addClientIcons/starYellowIcon.svg" class="" />
                                    </a>
                                  </div>
                                  <div class="add-row-start" *ngIf="!aSet.isFavorite">
                                    <a data-testid="lnk-unfavorite-address-contact" class="cursor-pointer" (click)="setAddressAsFavoriteContact(i)">
                                      <img src="../../../../assets/img/client/addClientIcons/starNormalIcon.svg" class="" />
                                    </a>
                                  </div>
                                  <div class="add-row-btn">
                                    <button type="button" class="cmn-inverse-btn" data-testid="btn-add-adrs-contact" [disabled]="activateButtonContact" mat-button (click)="addAddressSetContact()" *ngIf="i == 0 && addressSetsContact.length < 3">+ Address</button>
                                    <a class="cursor-pointer" data-testid="lnk-remove-address-contact" (click)="removeAddressContact(i)">
                                      <img src="../../../../assets/img/client/filter-icon/delete.svg" class="" />
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>



                      <div class="custom-field-container">
                        <h4 class="createclient-section-title">Custom fields </h4>
                        <div class="customs_fields_section" *ngFor="let cf of cfqlconitem; let i = index;">
                          <div class="createclient-section-row">
                            <div class="form-group form-group-sm">
                              <div class="custom-row" [ngClass]="{'align-items-center':cf.fieldType!='Checkbox'}">
                                <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
                                  <span *ngIf="cf.fieldType=='Header' && i == 0">
                                    {{cf.fieldLabel}} Custom fields
                                  </span>
                                  <span *ngIf="cf.fieldType=='Header' && i != 0">
                                    {{cf.fieldLabel}}
                                  </span>
                                  <span *ngIf="cf.fieldType!='Header'">
                                    {{cf.fieldLabel}}
                                  </span>
                                </h6>
                                <div class="col-5">
                                  <div class="form-input-container" *ngIf="cf.fieldType=='Text'">
                                    <input type="text"
                                           class="form-control"
                                           [placeholder]="cf.placeholder"
                                           #value="ngModel"
                                           [(ngModel)]="cf.value"
                                           name="value-{{i}}"
                                           autocomplete="off"
                                           maxlength="50"
                                           [readonly]="cf.isReadOnly" />
                                  </div>
                                  <div class="normal-form-select-arrow" *ngIf="cf.fieldType=='Dropdown List'">
                                    <select class="form-control" (change)="eventChangeInCustomConDropdown($event.target.value)" name="cfdropdown-{{i}}" #cfdropdown="ngModel" [(ngModel)]="cf.value">
                                      <option value="0">{{cf.placeHolder}}</option>
                                      <option *ngFor="let item of cf.cfdropdown" value="{{item.dropvalueId}}" text="{{item.dropvalue}}">
                                        {{item.dropvalue}}
                                      </option>
                                    </select>
                                  </div>
                                  <div *ngIf="cf.fieldType=='Checkbox'" class="d-flex flex-wrap">
                                    <div class="cmn-checkbox mr-3 mb-2" *ngFor="let item of cf.cfdropdown">
                                      <input id="{{item.dropvalueId}}"
                                             type="checkbox"
                                             class=""
                                             name="cfchkbox-{{i}}"
                                             [ngModelOptions]="{standalone: true}"
                                             [(ngModel)]="item.status"
                                             (change)="chkcustomqlConfield($event,item.dropvalueId,i);" />
                                      <label class="cmn-checkbox-text" for="cfchkbox-{{i}}">
                                        <span class="checkbox-square"></span>
                                        {{item.dropvalue}}
                                      </label>
                                    </div>
                                  </div>
                                  <div class="form-input-container" *ngIf="cf.fieldType=='Number'">
                                    <input type="number"
                                           class="form-control"
                                           #value="ngModel"
                                           [(ngModel)]="cf.value"
                                           name="value-{{i}}"
                                           autocomplete="off"
                                           [placeholder]="cf.placeholder"
                                           [readonly]="cf.isReadOnly"
                                           onkeypress="javascript: return event.target.value.length > 6 ? false : true"
                                           onkeydown="javascript: return event.keyCode == 69 ? false : true" />
                                  </div>
                                  <div class="form-input-container" *ngIf="cf.fieldType=='Link'">
                                    <input type="url" class="form-control" #value="ngModel" [(ngModel)]="cf.value" name="value-{{i}}" autocomplete="off" [placeholder]="cf.placeholder" [readonly]="cf.isReadOnly" />
                                  </div>
                                  <div class="form-datepicker-container cmn-material-datepicker" *ngIf="cf.fieldType=='Date'">
                                    <mat-form-field floatLabel="never" appearance="standard">
                                      <input class="cmn-mat-dtpicker-input" matInput
                                             #value="ngModel"
                                             (dateChange)="checkContactOnchangefield()"
                                             [(ngModel)]="cf.value" [matDatepicker]="ContactcfDatepicker"
                                             name="value-{{i}}" autocomplete="off" placeholder="dd/mm/yyyy" [disabled]="cf.isReadOnly != 'readonly' ? false : true">
                                      <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" matIconSuffix [for]="ContactcfDatepicker"></mat-datepicker-toggle>
                                      <mat-datepicker panelClass="cmn-datepicker-ui"
                                                      #ContactcfDatepicker></mat-datepicker>
                                      <mat-error class="cmn-material-datepicker-errormsg">
                                        Please enter the date in dd/mm/yyyy
                                      </mat-error>
                                    </mat-form-field>
                                    <!-- commented due to datepicker control change -->
                                    <!-- <ejs-datepicker cssClass=''
                                                    format='dd/MM/yyyy' placeholder='cf.placeholder'
                                                    [readonly]="cf.isReadOnly"
                                                    name="value-{{i}}" #value
                                                    [(ngModel)]="cf.value"
                                                    (change)="checkContactOnchangefield();"
                                                    openOnFocus='true' strictMode='true'></ejs-datepicker> -->
                                  </div>
                                  <div class="form-select-container" *ngIf="cf.fieldType=='User'">
                                    <div class="d-flex justify-content-start" *ngIf="!cf._isVisibleInput; else CfUserDropdown">
                                      <div *ngFor="let item of cf?._userInfo|slice:0:2" class="profile-round-items">
                                        <div class="profile_name_cicrle" [ngStyle]="{'background-color': item.backgroundColor, 'color': item.textColor}"
                                             matTooltipClass="cmn-tooltip-template" [matTooltip]="item.fullName">
                                          {{ item.shortName }}
                                        </div>
                                      </div>
                                      <div class="seemore-assignee-circle cursor-pointer" *ngIf="cf?._userInfo?.length>2" [matMenuTriggerFor]="menus"
                                           #menuTrigger="matMenuTrigger" (onclick)="closeSubMenu(menuTrigger)">
                                        +{{cf?._userInfo?.length-2}}
                                      </div>

                                      <div class="addassignee-cicrcle-btn">
                                        <button type="button" mat-button
                                                class="cmn-border-btn" (click)="showCFUserDropdown(cf)">
                                          +
                                        </button>
                                      </div>
                                      <mat-menu #menus="matMenu" [overlapTrigger]="false" [hasBackdrop]="true" class="create-assigne-custom-field">
                                        <div class="assignee-tooltip-items">
                                          <div *ngFor="let item of cf?._userInfo | slice:2" class="assignee-tooltip-items-name">
                                            {{item.fullName}}
                                          </div>
                                        </div>
                                      </mat-menu>
                                    </div>

                                    <ng-template #CfUserDropdown>
                                      <div class="form-multiselect-container addnew-assignee-input">
                                        <ng-multiselect-dropdown class="cmn-multiselect-dropdown flt-dropdown ellipsis-itemname"
                                                                 [placeholder]="'Select'" [settings]="cfUserDropdownSetting" [ngModelOptions]="{standalone: true}"
                                                                 [data]="cf.cfdropdown"
                                                                 [(ngModel)]="cf.value" (onDropDownClose)="hideCFUserDropdown(cf)"
                                                                 (ngModelChange)="onCFUserDropdownChange(cf)">
                                        </ng-multiselect-dropdown>
                                      </div>
                                    </ng-template>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <!--  -->
                    <div class="bottom_Line_addClient mt-1" *ngIf="contactHide"></div>
                    <div class="col-sm-12 mt-2 mb-2 createclient-footer-sticky" *ngIf="contactHide">
                      <div class="d-flex justify-content-between">
                        <button class="cmn-inverse-btn mr-auto" mat-button (click)="WarningPopupOpen(addcontactForm)" data-testid="btn-backto-contactlst">Go back to contact list</button>
                        <button type="submit" mat-button class="cmn-blue-btn" data-testid="btn-save-add-contact">Save & add contact</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <!-- Link End-->
              <!--Financial start-->
              <div class="financial-stepper-content" *ngIf="currentPage == 1">
                <div class="work-info-container">
                  <h4 class="createclient-section-title">Work</h4>
                  <div class="createclient-section-row">
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Industry</h6>
                        <div class="col-4">
                          <div class="form-select-container">
                            <ng-select [items]="industryList" class="cmn-ngselect"
                                       bindLabel="industryName"
                                       bindValue="industryName"
                                       [clearable]="true" name="industry" data-testid="drpdwn-industry" #industry="ngModel"
                                       [(ngModel)]="clientDataModal.industry"
                                       (change)="checkOnchangefield();" [ngClass]="{'is-invalid':addClientForm.submitted && industry.invalid }"
                                       placeholder="Select industry">
                            </ng-select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm" *ngIf="IsIndividual">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Role</h6>
                        <div class="col-4">
                          <div class="form-input-container">
                            <input type="text" class="form-control" autocomplete="off" name="role" [(ngModel)]="clientDataModal.role" placeholder="Enter role" data-testid="input-role" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm" *ngIf="clientDataModal.entityTypeId != 2 && clientDataModal.entityTypeId != 3 && clientDataModal.entityTypeId != 4 && clientDataModal.entityTypeId != 5">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Company name</h6>
                        <div class="col-4">
                          <div class="form-input-container">
                            <input type="text" class="form-control" autocomplete="off" name="companyName" [(ngModel)]="clientDataModal.companyName" placeholder="Enter company name" data-testid="input-company-name-work" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tax-info-container">
                  <h4 class="createclient-section-title">Tax</h4>
                  <div class="createclient-section-row">
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Tax client</h6>
                        <div class="col-4">
                          <div class="cmn-slide-toggle-container">
                            <mat-slide-toggle [(ngModel)]="clientDataModal.istaxclient" color="primary" name="istaxclintdd" data-testid="tgl-tax-client"></mat-slide-toggle>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">GST registered</h6>
                        <div class="col-4">
                          <div class="cmn-slide-toggle-container">
                            <mat-slide-toggle name="gST" [(ngModel)]="clientDataModal.gST" color="primary" data-testid="tgl-gst-registered"></mat-slide-toggle>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">TFN</h6>

                        <!--TFN element in Add Mode Start-->
                        <div class="col-4" *ngIf="!isEditMode">
                          <div class="form-input-container" *ngIf="!IsclientPrivacy && !isShowTFN" (click)="ShowTFN();">
                            Not recorded
                          </div>
                          <div class="form-input-container" *ngIf="(IsclientPrivacy && !isShowTFN) || (!IsclientPrivacy && isShowTFN )">
                            <input type="text" class="form-control" name="tFN" [mask]="'000 - 000 - 000'" [validation]="false" [dropSpecialCharacters]="true" autocomplete="off" [(ngModel)]="clientDataModal.tFN" placeholder="000 - 000 - 000" (blur)="tfnValidate();$event.preventDefault();" data-testid="input-tfn">
                            <div *ngIf="(clientDataModal.submitted && _tfnValidateStatus) || _tfnValidateStatus" class="invalid-feedback invalid">
                              TFN is invalid
                            </div>
                            <div *ngIf="(clientDataModal.submitted && TFNMessage != '') || TFNMessage != ''" class="invalid-feedback invalid">
                              {{TFNMessage}}
                            </div>
                          </div>
                        </div>
                        <!--TFN element in Add Mode End-->
                        <!--TFN element in Edit Mode Start-->
                        <div class="col-4" *ngIf="isEditMode">
                          <div class="form-input-container" *ngIf="((!IsclientPrivacy && !isShowTFN) || (IsclientPrivacy && !isShowTFN)) && (clientDataModal.tFN == '' || clientDataModal.tFN == undefined )" (click)="ShowTFN();">
                            Not recorded
                          </div>
                          <div class="form-input-container" *ngIf="((!IsclientPrivacy && !isShowTFN) || (IsclientPrivacy && !isShowTFN)) && clientDataModal.tFN != '' && clientDataModal.tFN != undefined " (click)="ShowTFN();">
                            Recorded
                          </div>
                          <div class="form-input-container" *ngIf="IsclientPrivacy && isShowTFN">
                            <input type="text" class="form-control" name="tFN" [mask]="'000 - 000 - 000'" [validation]="false" [dropSpecialCharacters]="true" autocomplete="off" [(ngModel)]="clientDataModal.tFN" placeholder="000 - 000 - 000" (blur)="tfnValidate();$event.preventDefault();" data-testid="input-tfn-alt"/>
                            <div *ngIf="(clientDataModal.submitted && _tfnValidateStatus) || _tfnValidateStatus" class="invalid-feedback invalid">
                              TFN is invalid
                            </div>
                            <div *ngIf="(clientDataModal.submitted && TFNMessage != '') || TFNMessage != ''" class="invalid-feedback invalid">
                              {{TFNMessage}}
                            </div>
                          </div>
                          <div class="form-input-container" *ngIf="!IsclientPrivacy && isShowTFN">
                            <input type="text" class="form-control" name="tFN" [mask]="'000 - 000 - 000'" [validation]="false" [dropSpecialCharacters]="true" autocomplete="off" [(ngModel)]="noPermissionTFNData" placeholder="000 - 000 - 000" (blur)="tfnValidateInNoPriacyPermission();$event.preventDefault();" data-testid="input-tfn-no-permission"/>
                            <div *ngIf="(clientDataModal.submitted && _tfnValidateStatus) || _tfnValidateStatus" class="invalid-feedback invalid">
                              TFN is invalid
                            </div>
                            <div *ngIf="(clientDataModal.submitted && TFNMessage != '') || TFNMessage != ''" class="invalid-feedback invalid">
                              {{TFNMessage}}
                            </div>
                          </div>
                        </div>
                        <!--TFN element in Edit Mode End-->

                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">ABN</h6>
                        <div class="col-4">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="aBN" mask="00 - 000 - 000 - 000" autocomplete="off" [(ngModel)]="clientDataModal.aBN" placeholder="00 - 000 - 000 - 000" (blur)="abnValidate();$event.preventDefault();" data-testid="input-abn"/>
                            <div *ngIf="(clientDataModal.submitted && _abnValidateStatus) || _abnValidateStatus" class="invalid-feedback invalid">
                              ABN is invalid
                            </div>
                            <div *ngIf="(clientDataModal.submitted && _isABNExist) || _isABNExist" class="invalid-feedback invalid">
                              ABN already exists
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">DIN</h6>
                        <!--DIN element in Add Mode Start-->
                        <div class="col-4" *ngIf="!isEditMode">
                          <div class="form-input-container" *ngIf="!IsclientPrivacy && !isShowDIN" (click)="ShowDIN();">
                            Not recorded
                          </div>
                          <div class="form-input-container" *ngIf="(IsclientPrivacy && !isShowDIN) || (!IsclientPrivacy && isShowDIN )">
                            <input type="text" class="form-control" name="dIN" mask="00000-00000-00000" autocomplete="off" minlength="15" [(ngModel)]="clientDataModal.dIN" placeholder="00000-00000-00000" (blur)="dinValidate();$event.preventDefault();" data-testid="input-din"/>
                            <div *ngIf="(clientDataModal.submitted && _dinValidateStatus) || _dinValidateStatus" class="invalid-feedback invalid">
                              DIN is invalid
                            </div>
                          </div>
                        </div>
                        <!--DIN element in Add Mode End-->
                        <!--DIN element in Edit Mode Start-->
                        <div class="col-4" *ngIf="isEditMode">
                          <div class="form-input-container" *ngIf="((!IsclientPrivacy && !isShowDIN) || (IsclientPrivacy && !isShowDIN)) && (clientDataModal.dIN == '' || clientDataModal.dIN == undefined )" (click)="ShowDIN();">
                            Not recorded
                          </div>
                          <div class="form-input-container" *ngIf="((!IsclientPrivacy && !isShowDIN) || (IsclientPrivacy && !isShowDIN)) && clientDataModal.dIN != '' && clientDataModal.dIN != undefined " (click)="ShowDIN();">
                            Recorded
                          </div>
                          <div class="form-input-container" *ngIf="IsclientPrivacy && isShowDIN">
                            <input type="text" class="form-control" name="dIN" mask="00000-00000-00000" autocomplete="off" minlength="15" [(ngModel)]="clientDataModal.dIN" placeholder="00000 - 00000 - 00000" (blur)="dinValidate();$event.preventDefault();" data-testid="input-din-edit"/>
                            <div *ngIf="(clientDataModal.submitted && _dinValidateStatus) || _dinValidateStatus" class="invalid-feedback invalid">
                              DIN is invalid
                            </div>
                          </div>
                          <div class="form-input-container" *ngIf="!IsclientPrivacy && isShowDIN">
                            <input type="text" class="form-control" name="dIN" mask="00000-00000-00000" autocomplete="off" minlength="15" [(ngModel)]="noPermissionDINData" placeholder="00000 - 00000 - 00000" (blur)="dinValidateInNoPriacyPermission();$event.preventDefault();" data-testid="input-din-no-permission"/>
                            <div *ngIf="(clientDataModal.submitted && _dinValidateStatus) || _dinValidateStatus" class="invalid-feedback invalid">
                              DIN is invalid
                            </div>
                          </div>
                        </div>
                        <!--DIN element in Edit Mode End-->
                      </div>
                    </div>

                    <div class="form-group form-group-sm" *ngIf="clientDataModal.entityTypeId != 1">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">ACN</h6>
                        <div class="col-4">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="aCN" mask="000 - 000 - 000" autocomplete="off" [(ngModel)]="clientDataModal.aCN" placeholder="000 - 000 - 000" (blur)="acnValidate();$event.preventDefault();" (keydown.enter)="$event.preventDefault(); acnValidate()" data-testid="input-acn"/>
                            <div *ngIf="(clientDataModal.submitted && _acnValidateStatus) || _acnValidateStatus" class="invalid-feedback invalid">
                              ACN is invalid
                            </div>
                            <div *ngIf="(clientDataModal.submitted && _isACNExist) || _isACNExist" class="invalid-feedback invalid">
                              ACN already exists
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="bank-info-container">
                  <h4 class="createclient-section-title">Bank</h4>
                  <div class="createclient-section-row">
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center popup-right-aligment-kc">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client left-kc-cmd-client">Financial institution</h6>
                        <div class="col-4">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="bankname" autocomplete="off" [(ngModel)]="clientDataModal.bankname" placeholder="Enter financial institution" data-testid="input-bankname"/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Account name</h6>
                        <div class="col-4">
                          <div class="form-input-container">
                            <input type="text" class="form-control" name="bankaccountname" autocomplete="off" [(ngModel)]="clientDataModal.bankaccountname" placeholder="Enter bank account name" data-testid="input-account-name"/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">BSB</h6>

                        <!--BSB element in Add Mode element Start-->
                        <div class="col-4" *ngIf="!isEditMode">
                          <div class="form-input-container" *ngIf="!IsclientPrivacy && !isShowBSB" (click)="ShowBSB();">
                            Not recorded
                          </div>
                          <div class="form-input-container" *ngIf="(IsclientPrivacy && !isShowBSB) || (!IsclientPrivacy && isShowBSB )">
                            <input type="text" class="form-control" name="bankBSB" mask="000 - 000" autocomplete="off" [(ngModel)]="clientDataModal.bankBSB" placeholder="Enter bank BSB" data-testid="input-bank-bsb"/>
                          </div>
                        </div>
                        <!--BSB element in Add Mode element End-->
                        <!--BSB element in Edit Mode element Start-->
                        <div class="col-4" *ngIf="isEditMode">
                          <div class="form-input-container" *ngIf="((!IsclientPrivacy && !isShowBSB) || (IsclientPrivacy && !isShowBSB)) && (clientDataModal.bankBSB == '' || clientDataModal.bankBSB == undefined )" (click)="ShowBSB();">
                            Not recorded
                          </div>
                          <div class="form-input-container" *ngIf="((!IsclientPrivacy && !isShowBSB) || (IsclientPrivacy && !isShowBSB)) && clientDataModal.bankBSB != '' && clientDataModal.bankBSB != undefined " (click)="ShowBSB();">
                            Recorded
                          </div>
                          <div class="form-input-container" *ngIf="IsclientPrivacy && isShowBSB">
                            <input type="text" class="form-control" name="bankBSB" mask="000 - 000" autocomplete="off" [(ngModel)]="clientDataModal.bankBSB" placeholder="Enter bank BSB" data-testid="input-bank-bsb-permission"/>
                          </div>
                          <div class="form-input-container" *ngIf="!IsclientPrivacy && isShowBSB">
                            <input type="text" class="form-control" name="bankBSB" mask="000 - 000" autocomplete="off" [(ngModel)]="noPermissionBSBData" placeholder="Enter bank BSB" (blur)="BSBValidateInNoPriacyPermission();" data-testid="input-bank-bsb-no-permission"/>
                          </div>
                        </div>
                        <!--BSB element in Edit Mode element End-->

                      </div>
                    </div>
                    <div class="form-group form-group-sm">
                      <div class="custom-row align-items-center">
                        <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">Account number</h6>

                        <!--Bank Account Number element in Add Mode Start-->
                        <div class="col-4" *ngIf="!isEditMode">
                          <div class="form-input-container" *ngIf="!IsclientPrivacy && !isShowBankAccountnumber" (click)="ShowBankAccountNo();">
                            Not recorded
                          </div>
                          <div class="form-input-container" *ngIf="(IsclientPrivacy && !isShowBankAccountnumber) || (!IsclientPrivacy && isShowBankAccountnumber )">
                            <input type="text" class="form-control" name="bankAccountnumber" autocomplete="off" [(ngModel)]="clientDataModal.bankAccountnumber" placeholder="Enter bank account number" data-testid="input-bank-account-number"/>
                          </div>
                        </div>
                        <!--Bank Account Number element in Add Mode End-->
                        <!--Bank Account Number element in Edit Mode Start-->
                        <div class="col-4" *ngIf="isEditMode">
                          <div class="form-input-container" *ngIf="((!IsclientPrivacy && !isShowBankAccountnumber) || (IsclientPrivacy && !isShowBankAccountnumber)) && (clientDataModal.bankAccountnumber == '' || clientDataModal.bankAccountnumber == undefined )" (click)="ShowBankAccountNo();">
                            Not recorded
                          </div>
                          <div class="form-input-container" *ngIf="((!IsclientPrivacy && !isShowBankAccountnumber) || (IsclientPrivacy && !isShowBankAccountnumber)) && clientDataModal.bankAccountnumber != '' && clientDataModal.bankAccountnumber != undefined " (click)="ShowBankAccountNo();">
                            Recorded
                          </div>
                          <div class="form-input-container" *ngIf="IsclientPrivacy && isShowBankAccountnumber">
                            <input type="text" class="form-control" name="bankAccountnumber" autocomplete="off" [(ngModel)]="clientDataModal.bankAccountnumber" placeholder="Enter bank account number" data-testid="input-bank-accunt-nmbr"/>
                          </div>
                          <div class="form-input-container" *ngIf="!IsclientPrivacy && isShowBankAccountnumber">
                            <input type="text" class="form-control" name="bankAccountnumber" autocomplete="off" [(ngModel)]="noPermissionAccountNumberData" placeholder="Enter bank account number" (blur)="BankAccNoValidateInNoPriacyPermission();" data-testid="input-bank-account-number-no-permission"/>
                          </div>
                        </div>
                        <!--Bank Account Number element in Edit Mode End-->

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--Financial End-->
            </div>
          </div>
          <div class="cmn-modal-footer" *ngIf="!contactHide">
            <button class="cmn-inverse-btn mr-auto" mat-button (click)="changePage1(-1)" *ngIf="currentPage > 0" data-testid="btn-previous">Previous</button>
            <button type="submit" mat-button class="cmn-blue-btn" id="next" (click)="changePage($event,1)" *ngIf="currentPage < 1  && !(clientDataModal.clientId > 0)" data-testid="btn-next">Next</button>
            <button type="button" mat-button class="cmn-blue-btn" (click)="clicktoDisable();updateClientInfo(1,addClientForm)" *ngIf="currentPage < 1  && clientDataModal.clientId >0" data-testid="btn-update-continue">Update & continue</button>
            <button type="submit" mat-button id="buttontext1" class="cmn-blue-btn" (click)="UpdateButtonClicked(); clicktoDisable();" data-testid="btn-update">{{buttontext}}</button>
            <button type="button" class="cmn-inverse-btn" mat-button (click)="cancelPopup(addClientForm);" data-testid="btn-cancel">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Common datepicker template -->
    <ng-template #commonDatepickerTemplate let-label="label" let-name="name" let-value="value" let-min="min" let-max="max" let-dataTestid="dataTestid" let-changeHandler="changeHandler" let-maxValueName="maxValueName">
      <div class="form-group form-group-sm">
        <div class="custom-row align-items-center">
          <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
            {{ label }}
          </h6>
          <div class="col-3">
            <div class="form-datepicker-container cmn-material-datepicker">
              <mat-form-field floatLabel="never" appearance="standard">
                <input class="cmn-mat-dtpicker-input" matInput [name]="name" autocomplete="off" placeholder="dd/mm/yyyy" [attr.data-testid]="dataTestid" [attr.aria-label]="label"
                       [min]="min ? (clientDataModal?.[min] || null) : null" [max]="clientDataModal?.[maxValueName] ? clientDataModal?.[maxValueName] : (max || null)" [(ngModel)]="clientDataModal[name]" #datePickerRef="ngModel" (dateChange)="changeHandler ? checkOnchangefield() : null" [matDatepicker]="picker" />
                <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker panelClass="cmn-datepicker-ui" #picker></mat-datepicker>

                <!-- Error 1: Generic invalid date format -->
                <mat-error class="cmn-material-datepicker-errormsg"
                           *ngIf="(!min && datePickerRef?.hasError('matDatepickerParse')) || (!datePickerRef?.hasError('matDatepickerMax') && (!min || !datePickerRef?.hasError('matDatepickerMin')))">
                  Please enter the date in dd/mm/yyyy
                </mat-error>

                <!-- Error 2: Invalid due to range (min/max) -->
                <mat-error class="cmn-material-datepicker-errormsg" *ngIf="datePickerRef?.hasError('matDatepickerMax') || (min && datePickerRef?.hasError('matDatepickerMin'))">
                  Please enter a valid {{ label | lowercase }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Common template for input fields -->
    <ng-template #commonInput let-label="label" let-name="name" let-placeholder="placeholder" let-maxlength="maxlength" let-dataCy="dataCy" let-changeFn="changeFn" let-isRequired="required">
      <div class="form-group form-group-sm">
        <div class="custom-row align-items-center">
          <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
            {{ label }}<span *ngIf="isRequired" class="text-danger">*</span>
          </h6>
          <div class="col-3">
            <div class="form-input-container">
              <input type="text" class="form-control" autocomplete="off" [attr.data-cy]="dataCy"
                     [name]="name" [maxlength]="maxlength" [(ngModel)]="clientDataModal[name]" [placeholder]="placeholder" [required]="isRequired"
                     #dynamicControlModel="ngModel" (change)="changeFn ? checkOnchangefield() : null" />
            </div>
            <span *ngIf="addClientForm?.submitted && dynamicControlModel?.invalid && isRequired" class="invalid-feedback invalid position_kc_step">
              <span *ngIf="dynamicControlModel.errors?.['required']">
                {{label}} is required
              </span>
            </span>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- Common template for Textarea fields -->
    <ng-template #commonTextArea let-label="label" let-name="name" let-placeholder="placeholder" let-dataTestid="dataTestid" let-changeFn="changeFn" let-isRequired="required">
      <div class="form-group form-group-sm">
        <div class="custom-row align-items-center">
          <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-client">
            {{ label }}<span *ngIf="isRequired" class="text-danger">*</span>
          </h6>
          <div [ngClass]="label == 'Mailing name' ? 'col-9' : 'col-3'">
            <div class="form-textarea-container mailingname-textarea">
              <textarea appTextareaAutoresize class="form-control" [name]="name" [attr.data-testid]="dataTestid" autocomplete="off" [placeholder]="placeholder" maxlength="500"
                        #dynamicControlModel="ngModel" [(ngModel)]="clientDataModal[name]" [required]="isRequired">
              </textarea>
            </div>
            <span *ngIf="addClientForm?.submitted && isRequired && dynamicControlModel?.invalid" class="invalid-feedback invalid position_kc_step">
              <span *ngIf="dynamicControlModel.errors?.['required']">
                {{label}} is required
              </span>
            </span>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- common template for Textarea fields end -->
  </form>
</div>


<ng-template #WarningPopupone>
  <div class="createclient-warning-popup">
    <div class="modal-content_data_fliter border_radies_filter_popup">
      <div class="wraningpopup_css border_radies_filter_popup_new">
        <div class="col-sm-12">
          <div class="d-flex justify-content-start">
            <div>
              <span><img src="../../../../assets/img/addclient/warningIcon.svg" width="21" height="21" /></span>
            </div>
            <div class="ml-2">
              <span class="warning_text_css">Warning</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12  mt-3 mb-2">
        <div class="new_font_waring_css">All unsaved data will be lost.</div>
        <div class="new_font_waring_css">
          Are you sure you want to continue?
        </div>
      </div>
      <div class="bottom_Line_new_line"></div>
      <div class="mb-2 mt-2">
        <div class="col-sm-12 pt-1">
          <div class="d-flex justify-content-end">
            <div class="">
              <button class="cmn-inverse-btn mr-3" mat-button (click)="closeclient(true,addClientForm,'No')" data-testid="btn-warning-no">No</button>
              <button type="button" mat-button class="cmn-blue-btn mr-3" (click)="closeclient(false,addClientForm,'Yes')" data-testid="btn-warning-yes">Yes</button>
              <button type="button" mat-button class="cmn-blue-btn" (click)="closeclient(false,addClientForm,'SaveClose')" data-testid="btn-warning-save-close">Save & Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #generateFormPopupRef>
  <app-ni-generateform-popup [sourceComponent]="'contactComponent'" [changedNewPhyAddress]="changedNewPhyAddress" [clientData]="clientData" [_tempClientDetails]="_tempClientDetails" [oldPhysicalAddressId]="oldPhysicalAddressId" [newPhyAddressId]="newPhyAddressId" [newPhysicalAddressLine]="newPhysicalAddressLine" [newPhyAddresscareOf]="newPhyAddresscareOf"></app-ni-generateform-popup>
</ng-template>

<ng-template #CreateNewAddress>
  <form #createAddressForm="ngForm" (ngSubmit)="addAddress()">
    <div class="col-sm-12 p-0">
      <div class="">
        <div class="cmn-modal-header">
          <h4 class="modal-header-title">Create address</h4>
        </div>
        <div class="cmn-modal-content">
          <div class="form-group form-group-sm">
            <div class="custom-row align-items-center">
              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-address-labels">Unit</h6>
              <div class="col-8">
                <div class="form-input-container">
                  <input type="text" class="form-control" autocomplete="off" name="Unit" [(ngModel)]="addressData.unit" placeholder="Enter unit" data-testid="input-unit"/>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group form-group-sm">
            <div class="custom-row align-items-center">
              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-address-labels">Address line 1<span class="error-text">*</span></h6>
              <div class="col-8">
                <div class="form-input-container">
                  <input type="text" class="form-control" autocomplete="off" name="Addressline1" [(ngModel)]="addressData.addressLine1" placeholder="Enter address line 1" required #addLine="ngModel" [class.is-invalid]="addLine.invalid && (addLine.dirty || addLine.touched)" data-testid="input-addressline1"/>
                  <div *ngIf="addLine.invalid && (addLine.dirty || addLine.touched)" class="invalid-feedback invalid entity-type-cmd error-messge-kc">
                    This field is required
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group form-group-sm">
            <div class="custom-row align-items-center">
              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-address-labels">Address line 2</h6>
              <div class="col-8">
                <div class="form-input-container">
                  <input type="text" class="form-control" autocomplete="off" name="Addressline2" [(ngModel)]="addressData.addressLine2" placeholder="Enter address line 2" data-testid="input-addressline2"/>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group form-group-sm">
            <div class="custom-row align-items-center">
              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-address-labels">Suburb<span class="error-text">*</span></h6>
              <div class="col-8">
                <div class="form-input-container">
                  <input type="text" class="form-control" autocomplete="off" name="Suburb" [(ngModel)]="addressData.suburb" placeholder="Enter suburb" required #suburb="ngModel" [class.is-invalid]="suburb.invalid && (suburb.dirty || suburb.touched)" data-testid="input-suburb"/>
                </div>
                <div *ngIf="suburb.invalid && (suburb.dirty || suburb.touched)" class="invalid-feedback invalid entity-type-cmd error-messge-kc">
                  This field is required
                </div>
              </div>
            </div>
          </div>
          <div class="form-group form-group-sm">
            <div class="custom-row align-items-center">
              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-address-labels">State<span class="error-text">*</span></h6>
              <div class="col-8">
                <div class="form-select-container">
                  <ng-select [items]="stateList" class="cmn-ngselect"
                             bindLabel="name"
                             bindValue="stateId"
                             [clearable]="true" name="State"
                             placeholder="Select state"
                             [(ngModel)]="selectedStateId"
                             required
                             #state="ngModel"
                             [class.is-invalid]="state.invalid && (state.dirty || state.touched)"
                             data-testid="drpdwn-state">
                  </ng-select>
                </div>
                <div *ngIf="state.invalid && (state.dirty || state.touched)" class="invalid-feedback invalid entity-type-cmd error-messge-kc">
                  This field is required
                </div>
              </div>
            </div>
          </div>

          <div class="form-group form-group-sm">
            <div class="custom-row align-items-center">
              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-address-labels">Post code<span class="error-text">*</span></h6>
              <div class="col-8">
                <div class="form-input-container">
                  <input type="text" class="form-control" autocomplete="off" name="Postcode" [(ngModel)]="addressData.postcode" placeholder="Enter postcode" required #postcode="ngModel" [class.is-invalid]="postcode.invalid && (postcode.dirty || postcode.touched)" data-testid="input-postcode"/>
                </div>
                <div *ngIf="postcode.invalid && (postcode.dirty || postcode.touched)" class="invalid-feedback invalid entity-type-cmd error-messge-kc">
                  This field is required
                </div>
              </div>
            </div>
          </div>
          <div class="form-group form-group-sm">
            <div class="custom-row align-items-center">
              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-address-labels">Country<span class="error-text">*</span></h6>
              <div class="col-8">
                <div class="form-select-container">
                  <ng-select [items]="contactcountries" class="cmn-ngselect" data-testid="select-country"
                             bindLabel="name"
                             bindValue="countryId"
                             [clearable]="true" name="Country"
                             placeholder="Select country"
                             [(ngModel)]="selectedCountryId"
                             (ngModelChange)="onCountryChange($event)"
                             required
                             #country="ngModel"
                             [class.is-invalid]="country.invalid && (country.dirty || country.touched)"
                             data-testid="drpdwn-country">
                  </ng-select>
                </div>
                <div *ngIf="country.invalid && (country.dirty || country.touched)" class="invalid-feedback invalid entity-type-cmd error-messge-kc">
                  This field is required
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cmn-modal-footer">
          <button type="submit" mat-button class="cmn-blue-btn" [disabled]="!createAddressForm.form.valid" data-testid="btn-add-address">Add</button>
          <button type="button" class="cmn-inverse-btn" mat-button (click)="createAddressPopupclose()" data-testid="btn-cancel-address">Cancel</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>
<!-- Bulk Email Update-->
<ng-template #BulkEmailUpdate>
  <div class="bulk-email-update-container">
    <form class="col-sm-12 p-0" #BulkUpdateEmailForm="ngForm" novalidate>

      <div class="cmn-modal-header">
        <h4 class="modal-header-title">
          Bulk email update
        </h4>
      </div>

      <div class="cmn-modal-content">

        <!-- STEP 1 -->
        <div class="bulkaddress-content" *ngIf="modalScreen === 1">

          <p class="blk-updt-desc">
            We have identified the Clients/Contacts associated with the updated emails.
            Please select the Clients/Contacts you wish to update:
          </p>

          <!-- LOOP GROUPS -->
          <div *ngFor="let group of bulkEmailGroups; let gIndex = index">

            <!-- Group Heading -->
            <h5 class="blk-updt-frm-to" *ngIf="group.toEmail !== 'Removed'">
              From "{{ group.fromEmail }}" → To "{{ group.toEmail }}"
            </h5>

            <h5 class="blk-updt-frm-to" *ngIf="group.toEmail === 'Removed'">
              Removed - "{{ group.fromEmail }}"
            </h5>

            <!-- Select All Per Group -->
            <div class="cmn-checkbox mb-2">
              <input type="checkbox"
                     class="checkbox_status cursor-pointer"
                     id="checkAllEmail-{{gIndex}}"
                     [(ngModel)]="group._isCheckAll"
                     name="checkAllEmail-{{gIndex}}"
                     (ngModelChange)="toggleAllEmails(group)">

              <label class="cmn-checkbox-text"
                     for="checkAllEmail-{{gIndex}}">
                <span class="checkbox-square"></span>
                {{group._isCheckAll ? 'Unselect' : 'Select'}} all
              </label>
            </div>

            <!-- Entities inside group -->
            <ng-container *ngFor="let entity of group.entities; let i = index">

              <div class="cmn-checkbox mb-2">
                <input type="checkbox"
                       class="checkbox_status cursor-pointer"
                       id="checkEmail-{{gIndex}}-{{i}}"
                       name="checkEmail-{{gIndex}}-{{i}}"
                       [(ngModel)]="entity._isChecked"
                       (ngModelChange)="updateCheckAllStatus(group)">

                <label class="cmn-checkbox-text"
                       for="checkEmail-{{gIndex}}-{{i}}" style="display: flex; align-items: flex-start; gap: 8px;">
                  <span class="checkbox-square" style="flex-shrink: 0;"></span>


                  {{entity.name}} | {{entity.entityType}} | {{entity.emailTypeName}}
                </label>
              </div>

            </ng-container>

            <hr />

          </div>

        </div>

      </div>


      <!-- FOOTER -->
      <div class="cmn-modal-footer">

        <button mat-button type="button"
                class="cmn-blue-btn"
                *ngIf="modalScreen === 1"
                (click)="onSubmitBulkEmailUpdate()"
                data-testid="btn-update-email">
          Update
        </button>

        <button type="button"
                class="cmn-inverse-btn"
                (click)="onCancel()"
                data-testid="btn-cancel-bulk-email">
          Cancel
        </button>

      </div>

    </form>
  </div>
</ng-template>

<!-- Bulk Email Update-->